// FizzyIQ — PDP hero + buy box interactions
// Ported from 02 PDP FizzyFocus v3.html. Self-initializes on DOMContentLoaded.
(function () {
  function init() {
    var hero = document.getElementById('pdpHero');
    if (!hero) return;

    // Read the inert JSON once the deferred section script initializes.
    // An absent/invalid payload clears any stale editor state and fails closed.
    var stickPayload = document.getElementById('fizzy-pdp-stick');
    window.__fizzyPdpStick = null;
    if (stickPayload) {
      try { window.__fizzyPdpStick = JSON.parse(stickPayload.textContent); }
      catch (error) { console.error('[FizzyIQ] stick pack data unavailable'); }
    }

    // The real vendor iframe is present at parse time. Its ready handshake
    // must work on preview URLs too, independently of the lower reviews widget.
    (function initFrontrowBadge() {
      var frame = hero.querySelector('#iframe-frontrow-quant');
      if (!frame || frame.dataset.fizzyBound === 'true') return;
      frame.dataset.fizzyBound = 'true';
      var origin = 'https://app.thefrontrowhealth.com';
      var loader = document.querySelector('script[data-fizzy-quant-loader]');
      frame.dataset.frontrowState = 'loading';
      function ready() {
        // The frame owns the ready handshake. Do not gate this on the parent
        // loader: a third-party storage/tracking error must not prevent the
        // genuine badge document from initializing.
        if (frame.isConnected && frame.contentWindow) {
          frame.contentWindow.postMessage({ name: 'PARENT_READY' }, origin);
        }
      }
      function onMessage(event) {
        if (event.origin !== origin || event.source !== frame.contentWindow) return;
        var data = event.data;
        var name = typeof data === 'string' ? data : data && data.name;
        if (name === 'QUANT_REQUEST_READY_STATUS') ready();
        if (name === 'RESIZE_HEIGHT' && data && Number.isFinite(data.value) && data.value >= 20 && data.value <= 1000) {
          frame.dataset.frontrowState = 'ready';
          frame.style.height = data.value + 'px';
          frame.style.display = 'block';
        }
      }
      function onVendorLoad() {
        loader.dataset.ready = 'true';
        ready();
      }
      window.addEventListener('message', onMessage);
      frame.addEventListener('load', ready);
      if (!loader) {
        loader = document.createElement('script');
        loader.dataset.fizzyQuantLoader = 'true';
        loader.src = origin + '/api/widgets/script?id=3096';
        loader.defer = true;
        loader.addEventListener('load', onVendorLoad, { once: true });
        document.head.appendChild(loader);
      } else if (loader.dataset.ready === 'true') {
        ready();
      } else {
        loader.addEventListener('load', onVendorLoad, { once: true });
      }
    })();

    // Keep the mobile header opaque only while it crosses the light purchase area.
    var purchaseSurface = hero.querySelector('.pdp-purchase-surface');
    var purchaseHeader = document.querySelector('.gh');
    if (purchaseSurface && purchaseHeader) {
      var purchaseMobile = window.matchMedia('(max-width: 820px)');
      var purchaseFrame = 0;
      function updatePurchaseHeader() {
        purchaseFrame = 0;
        var active = false;
        if (purchaseMobile.matches && purchaseSurface.isConnected) {
          var bounds = purchaseSurface.getBoundingClientRect();
          var headerEdge = purchaseHeader.getBoundingClientRect().bottom;
          active = bounds.top <= headerEdge && bounds.bottom > headerEdge;
        }
        document.body.classList.toggle('pdp-purchase-header', active);
      }
      function schedulePurchaseHeader() {
        if (!purchaseFrame) purchaseFrame = requestAnimationFrame(updatePurchaseHeader);
      }
      window.addEventListener('scroll', schedulePurchaseHeader, { passive: true });
      window.addEventListener('resize', schedulePurchaseHeader, { passive: true });
      window.addEventListener('pageshow', schedulePurchaseHeader);
      window.addEventListener('load', schedulePurchaseHeader);
      purchaseMobile.addEventListener('change', schedulePurchaseHeader);
      if ('ResizeObserver' in window) {
        var purchaseResize = new ResizeObserver(schedulePurchaseHeader);
        purchaseResize.observe(hero);
        purchaseResize.observe(purchaseSurface);
        purchaseResize.observe(purchaseHeader);
      }
      updatePurchaseHeader();
    }

    // ── flavor catalog (label + short taste note) ──
    var FLAV = {
      bc: { name: 'Berry Cherry',        taste: 'Mixed berries with a tart cherry finish — bold, balanced, not too sweet.' },
      sl: { name: 'Strawberry Lemonade', taste: 'Fresh strawberry meets bright lemonade — the sweet-tart classic kids ask for by name.' },
      wm: { name: 'Watermelon',          taste: 'Crisp, lightly sweet watermelon — clean and naturally refreshing.' },
      ob: { name: 'Orange Creamsicle',   taste: 'Bright orange citrus with a creamy finish — like a fizzy creamsicle, minus the sugar.' }
    };

    // Per-flavor hero videos (updated 2026-05-15 — compressed visualizer set).
    var FLAVOR_VIDEO = {
      bc: 'https://cdn.shopify.com/videos/c/o/v/6ea3ab5db29b47cda1308e50040a3e58.mp4',
      sl: 'https://cdn.shopify.com/videos/c/o/v/8deb1650bf26476da5779c9a39acc01d.mp4',
      wm: 'https://cdn.shopify.com/videos/c/o/v/d6004e1f825b4308b60f18c25b6c9b82.mp4',
      ob: 'https://cdn.shopify.com/videos/c/o/v/ba8aa019128042e39419f1f364ac66e7.mp4'
    };

    // Per-flavor "drink with benefits" stills shown as carousel slide 1.
    // The image swaps when the user previews a different flavor; the
    // overlay icons + labels are static HTML (see fizzy-pdp-hero.liquid).
    // Updated 2026-05-19 with refreshed Group_* art. Mapping confirmed
    // by Sam: 725=BC, 731=SL, 732=WM, 730=OB.
    var DRINK_BENEFITS_IMG = {
      // Refreshed JPGs 2026-05-28 (v=1780002433) — same Group_* mapping
      // (bc=725, sl=731, wm=732, ob=730), now in JPG format.
      bc: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/pdphero_keybenefits_newgray_berrycherry.jpg?v=1781239796&width=1440',
      sl: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/pdphero_keybenefits_newgray_strawberrylemonade.jpg?v=1781239793&width=1440',
      wm: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/pdphero_keybenefits_newgray_watermelon.jpg?v=1781239799&width=1440',
      ob: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/pdphero_keybenefits_newgray_orangecreamsicle.jpg?v=1781239797&width=1440'
    };
    // Slide 4 — flavor-aware deep-color drink backdrop for the
    // "Clinically Studied Ingredient Benefits" composition. Cards +
    // copy are HTML overlays in fizzy-pdp-hero.liquid; only the
    // background image swaps src per flavor.
    var CLINICAL_BG_IMG = {
      bc: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/berry2.png?v=1779059040&width=900',
      sl: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/strawberry2.png?v=1779059034&width=900',
      wm: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/watermelon2.png?v=1779059031&width=900',
      ob: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/orange2.png?v=1779059037&width=900'
    };
    // Slide 7 — flavor-aware "what's included" composition on a
    // hardcoded paper-cream background (set inline in the section
    // markup). No HTML overlay — pure image swap per flavor.
    var INCLUDED_IMG = {
      // Refreshed JPGs 2026-05-28 (v=1780002435/6). 2026-05-30: BC
      // reverted from hero_testimonial.jpg back to berrycherry3.jpg
      // per Sam — the testimonial composition moved up to slide
      // data-i="8" for ALL flavors (no flavor-swap on that slide),
      // and this slot is now the unified *3.jpg pouch composition.
      bc: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Rebranded_Berry_Cherry.jpg?v=1781237491&width=1440',
      sl: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Strawberry_Lemonade.jpg?v=1781237491&width=1440',
      wm: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Credibility_Watermelon.jpg?v=1781237491&width=1440',
      ob: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Rebranded_Image.jpg?v=1781237491&width=1440'
    };
    // Slide — flavor-aware lifestyle image. Each flavor gets its
    // own kitchen-scene lifestyle photo tinted to the flavor's brand
    // color. Swapped by applyFlavorLifestyleImage below; the thumb
    // at #lifestyleThumbImg mirrors the main image. Added 2026-05-22.
    var FLAVOR_LIFESTYLE_IMG = {
      // Refreshed 2026-05-28 (v=1780002436) to the new "Simple steps.
      // Big Results." 4-image strip per flavor. Filenames are GUID-
      // suffixed in Shopify Files to avoid collision with the legacy
      // berry.jpg / strawberry.jpg / watermelon.jpg / orange.jpg.
      bc: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_How_to_Use_Berry_Cherry.jpg?v=1781237491&width=1440',
      sl: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_How_to_Use_Strawberry_Lemonade.jpg?v=1781237491&width=1440',
      wm: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/How_to_Use_New_Gray_Watermelon.jpg?v=1781237491&width=1440',
      ob: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_How_to_Use_Orange_Creamsicle.jpg?v=1781237491&width=1440'
    };
    // Slide — second flavor-aware lifestyle image. Inserted as the
    // 3rd carousel slide (data-i="2") on 2026-05-26 to give each
    // flavor a second lifestyle showcase. Swapped by
    // applyFlavorLifestyle2Image; thumb mirrored via #lifestyleThumbImg2.
    var FLAVOR_LIFESTYLE2_IMG = {
      // Refreshed 2026-05-28 (v=1780005532-56) — new "All of the good
      // stuff. None of the bad." flavor photography. Filenames are
      // GUID-suffixed in Shopify Files to avoid collision with the
      // legacy berry2.jpg / strawberry2.jpg / etc.
      bc: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Trust_Badges_Berry_Cherry.jpg?v=1781237491&width=1440',
      sl: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Trust_Badges_Strawberry.jpg?v=1781237492&width=1440',
      wm: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Trust_Badges_Watermelon.jpg?v=1781237491&width=1440',
      ob: 'https://cdn.shopify.com/s/files/1/0631/8915/5937/files/FizzyIQ_Trust_Badges_New_Gray_Orange.jpg?v=1781237491&width=1440'
    };
    // Slide 9 — flavor-aware Supplement Facts panel. Each variant
    // has its own SFP rendered as a flat image (added 2026-05-19).
    // Mapping confirmed by Sam: 18=SL, 21=BC, 19=OB, 16=WM.
    var SFP_IMG = {
      bc: 'https://cdn.shopify.com/s/files/1/0756/5194/0663/files/berrycherrySFP.jpg?v=1781291696&width=1440',
      sl: 'https://cdn.shopify.com/s/files/1/0756/5194/0663/files/strawberrySFP.jpg?v=1781291700&width=1440',
      wm: 'https://cdn.shopify.com/s/files/1/0756/5194/0663/files/watermelonSFP.jpg?v=1781291698&width=1440',
      ob: 'https://cdn.shopify.com/s/files/1/0756/5194/0663/files/orangeSFP.jpg?v=1781291702&width=1440'
    };

    // Flavor grounds (Sam 2026-09-21): the gallery stills drawn on the flat
    // grey ground have one version per flavor on that flavor's light ground,
    // served as theme assets. Liquid writes the four URLs onto each <img> as
    // data-ground-bc/sl/wm/ob; this reads them back as a flavor -> URL map.
    function groundMap(el) {
      if (!el || !el.dataset || !el.dataset.groundBc) return null;
      var abs = function (u) { try { return new URL(u, window.location.href).href; } catch (e) { return u; } };
      var d = el.dataset;
      return { bc: abs(d.groundBc), sl: abs(d.groundSl), wm: abs(d.groundWm), ob: abs(d.groundOb) };
    }

    // ── plan + pricing config ──
    // Pricing is sourced from the product's live variant metadata (admin =
    // single source of truth), injected as window.__fizzyPdpPrices by the
    // section liquid. Values arrive in cents; compare-at drives "was" + save%.
    var PLAN_MONTHS = { '1m': 1, '2m': 2, '3m': 3 };
    function money(amount, decimals) {
      if (typeof amount !== 'number' || !isFinite(amount)) return 'Unavailable';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: window.__fizzyPdpCurrency || 'USD',
        minimumFractionDigits: decimals === true || amount % 1 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(amount);
    }
    function unavailablePrice() {
      return { price: null, was: 0, save_amt: 0, save_pct: 0, available: false };
    }
    function priceFromCents(cents, compare, available) {
      if (!Number.isFinite(Number(cents)) || Number(cents) <= 0 || available === false) return unavailablePrice();
      var price = Number(cents) / 100;
      var was = Number(compare) > Number(cents) ? Number(compare) / 100 : 0;
      return { price: price, was: was, save_amt: was ? was - price : 0,
        save_pct: was ? Math.round((was - price) / was * 100) : 0, available: true };
    }
    function priceFor(age, plan) {
      var tbl = window.__fizzyPdpPrices || {};
      var src = tbl[age] && tbl[age][plan];
      return src ? priceFromCents(src.price, src.was, src.available) : unavailablePrice();
    }
    var PLAN_LABELS = { '1m': 'Monthly', '2m': '2-month', '3m': '3-month' };
    // Long-form plan strings written to cart line-item properties.
    // Hoisted to module scope so both the ATC handler and the sticky
    // ATC sync (syncStickyAtc) can read from one source of truth.
    // 2026-05-30: 2-month restored alongside Monthly + 3-month.
    var PLAN_PROPERTY = {
      '1m': 'Monthly Delivery',
      '2m': '2-month Delivery',
      '3m': '3-month Delivery',
      'stick15': 'Build your stickpack bundle'
    };

    var state = {
      plan: '1m',
      stickQuantity: 15,
      /* Single age selection — 8–13 (1 serving/day) or 14+ (2/day, the
         adult dose). Simplified back from the household picker on
         2026-06-03 per Sam. */
      age: window.__fizzyPdpInitialAge === '14+' ? '14+' : '8-13',
      // Flavors are chosen explicitly; the product preview never fills the box.
      qty: { bc: 0, sl: 0, wm: 0, ob: 0 }
    };
    /* Bundle price for the selected age + plan (from live variant metadata).
       Box mode: the price matrix is empty (Classic Box variants are titled by
       size, not by age/plan strings), so read the size variant's price. */
    // Stick packs share this builder and cart path, with their own parent/children.
    function isStickPlan(plan) { return (plan || state.plan) === 'stick15'; }
    function stickData() { return window.__fizzyPdpStick || {}; }
    function stickSize(quantity) {
      var size = Number(quantity || state.stickQuantity);
      return [15, 30, 60].indexOf(size) !== -1 ? size : 15;
    }
    function stickDays(quantity) { return stickSize(quantity) === 15 ? 15 : 30; }
    function stickPlanId(quantity) {
      var map = stickData().planMap || {};
      for (var name in map) {
        if (new RegExp('(^|\\D)' + stickDays(quantity) + '\\s+days?(?![a-z])', 'i').test(name) && /^[1-9]\d*$/.test(String(map[name]))) return map[name];
      }
      return null;
    }
    function stickVariant(quantity) {
      var size = stickSize(quantity), data = stickData();
      if (!data.enabled || !Array.isArray(data.variants)) return null;
      return data.variants.find(function (v) {
        return new RegExp('^' + size + '(?:\\s+(?:items|sticks))?$', 'i').test(String(v.option1).trim());
      }) || null;
    }
    function stickChildFor(f) {
      var map = stickData().childMap || {};
      var names = {bc:'berrycherry',sl:'strawberrylemonade',wm:'watermelon',ob:'orangecreamsicle'};
      for (var name in map) {
        if (name.toLowerCase().replace(/[^a-z0-9]/g, '') !== names[f]) continue;
        var value = map[name], id = value && typeof value === 'object' ? value.id : value;
        if (!/^[1-9]\d*$/.test(String(id))) return null;
        return {id:id,option:name};
      }
      return null;
    }
    function stickPrice(quantity) {
      var variant = stickVariant(quantity), plan = stickPlanId(quantity);
      if (!variant || !plan || !['bc','sl','wm','ob'].every(stickChildFor)) return unavailablePrice();
      var allocation = (variant.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === String(plan); });
      // Never substitute a parent price or another selling plan for this subscription.
      return allocation ? priceFromCents(allocation.price, 0, variant.available) : unavailablePrice();
    }
    function quantityStep() { return isStickPlan() ? 3 : 1; }
    function stickStock(f) {
      var stock = stickData().childStock, child = stickChildFor(f);
      if (!child) return 0;
      if (!stock) return Infinity;
      for (var name in stock) {
        if (name.toLowerCase().replace(/[^a-z0-9]/g, '') === child.option.toLowerCase().replace(/[^a-z0-9]/g, '')) {
          var value = Number(stock[name]);
          return Number.isFinite(value) ? Math.max(0, value) : 0;
        }
      }
      return Infinity;
    }
    function exactSelection() {
      var req = required();
      return req > 0 && selectedCount() === req && ['bc','sl','wm','ob'].every(function (f) {
        var q = state.qty[f];
        return Number.isInteger(q) && q >= 0 && (!isStickPlan() || q % 3 === 0) &&
          (!q || (flavorAvail(f) && q <= flavorStock(f)));
      });
    }
    function resetFlavorCounts() { ['bc','sl','wm','ob'].forEach(function (f) { state.qty[f] = 0; }); }

    function boxPlanIdFor(age, plan) {
      var days = PLAN_MONTHS[plan] * 30;
      if (!days) return null;
      var map = boxDataFor(age).planMap;
      for (var name in map) {
        if (new RegExp('(^|\\D)' + days + '(?!\\d)').test(name)) return map[name];
      }
      return null;
    }
    function regularTierPrice(plan) {
      if (isStickPlan(plan)) return stickPrice();
      if (!window.__fizzyPdpChildMap) return priceFor(state.age, plan);
      var months = PLAN_MONTHS[plan];
      var planId = boxPlanIdFor(state.age, plan);
      if (!months || !planId) return unavailablePrice();
      var size = months * (state.age === '14+' ? 2 : 1);
      var list = boxDataFor(state.age).variants;
      for (var i = 0; i < list.length; i++) {
        var variant = list[i];
        if (String(variant.option1).trim() !== String(size)) continue;
        var cents = variant.price;
        var allocations = variant.selling_plan_allocations || [];
        var allocation = allocations.find(function (item) { return String(item.selling_plan_id) === String(planId); });
        if (allocations.length && !allocation) return unavailablePrice();
        if (allocation) cents = allocation.price;
        // Intro pricing (Skio set price): strike the regular subscription price (variant price).
        var p = priceFromCents(cents, allocation ? variant.price : variant.compare_at_price, variant.available);
        var adj = allocation && allocation.price_adjustments;
        if (p.available && adj && adj.length > 1 && Number(adj[1].price) > 0) p.renewal = Number(adj[1].price) / 100;
        return p;
      }
      return unavailablePrice();
    }
    // Mirrors the automatic subscription discount; Shopify calculates checkout totals.
    function octoberOfferActive() {
      return false; // October 20%-every-box offer ended at the Oct 23 intro-pricing launch.
    }
    function tierPrice(plan) {
      var p = regularTierPrice(plan);
      if (!p.available || !octoberOfferActive()) return p;
      var discounted = Math.round(p.price * 80) / 100;
      if (isStickPlan(plan)) {
        // Shopify's product discount truncates the discount to whole cents.
        // Subtract that amount instead of rounding the final discounted price.
        var cents = Math.round(p.price * 100);
        discounted = (cents - Math.floor(cents * 20 / 100)) / 100;
      }
      return {price: discounted, was: p.price, save_amt: p.price - discounted, save_pct: 20, available: true};
    }
    function subscriptionRenewalText(plan) {
      var regular = regularTierPrice(plan), offer = tierPrice(plan);
      if (!regular.available || !offer.available) return 'Plan unavailable.';
      var days = isStickPlan(plan) ? stickDays() : (PLAN_MONTHS[plan] || 1) * 30;
      return octoberOfferActive()
        ? money(offer.price) + ' every ' + days + ' days.'
        : regular.renewal && regular.renewal !== regular.price
          ? money(regular.price) + ' first box, then ' + money(regular.renewal) + ' every ' + days + ' days.'
          : money(regular.price) + ' every ' + days + ' days.';
    }
    function stickRenewalText() { return subscriptionRenewalText('stick15'); }
    function stickPlanLabel() { return stickSize() + '-stick bundle'; }
    /* Cart line-item label for the chosen age. */
    function ageLabel() { return state.age === '14+' ? 'Ages 14+' : 'Ages 8–13'; }
    // Static Box mode (Skio): the child pouch product's variants, emitted by the
    // section when box_child_product is set. Keys are the child's option strings;
    // self-contained normalizer so 'Water Melon' and 'Watermelon' both resolve.
    function boxChildFor(f) {
      var cm = window.__fizzyPdpChildMap;
      if (!cm) return null;
      var names = { bc: 'berrycherry', sl: 'strawberrylemonade', wm: 'watermelon', ob: 'orangecreamsicle' };
      var want = names[f];
      for (var k in cm) {
        if (String(k).toLowerCase().replace(/[^a-z0-9+]/g, '') === want) {
          // Flat map (option string → variant id). Flat is required: nested JSON
          // ends in '}}', which Shopify rejects as Liquid syntax in template
          // settings. Object values still accepted for forward-compat.
          var v = cm[k];
          return (v && typeof v === 'object') ? v : { id: v, option: k };
        }
      }
      return null;
    }
    // Resolve by age, independently of which product route rendered this page.
    // Never substitute another age's variants or selling plans when data is absent.
    function boxDataFor(age) {
      var data = (window.__fizzyPdpBoxes || {})[age] || {};
      return { variants: Array.isArray(data.variants) ? data.variants : [], planMap: data.planMap || {} };
    }
    // A flavor is in stock for the current age + plan if its bundle variant is
    // available. Shopify computes that from the child SKU, so this reflects true
    // stock. Fail open (treat as available) if the map is missing. Frontend only.
    function flavorAvail(f, plan) {
      if (isStickPlan(plan)) return !!stickChildFor(f) && stickStock(f) >= 3;
      // Box mode: the box parent has no flavor axis, so stock lives on the
      // child pouch variant itself. The child product is unpublished, so the
      // section bridges its availability through the box product's
      // fizzy.child_stock metafield (__fizzyPdpChildStock, keyed by the same
      // option strings as the child map). Absent metafield = fail open.
      if (window.__fizzyPdpChildMap) {
        var c = boxChildFor(f);
        if (!c) return true;
        var st = window.__fizzyPdpChildStock;
        if (st) {
          var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9+]/g, ''); };
          for (var sk in st) {
            if (norm(sk) === norm(c.option)) return Number(st[sk]) > 0;
          }
        }
        return c.available !== false;
      }
      var m = window.__fizzyPdpAvail, byAge = m && m[state.age], byPlan = byAge && byAge[typeof plan === 'string' ? plan : state.plan];
      if (!byPlan) return true;
      return byPlan[f] !== false;
    }
    // Remaining child stock for a flavor (box mode). The bundle builder caps
    // each flavor's quantity at this number — 1 unit left means at most 1 in
    // the box. Infinity when the stock bridge is absent (fail open) or in
    // legacy mode (parent variants gate availability wholesale there).
    function flavorStock(f, plan) {
      if (isStickPlan(plan)) return Math.floor(stickStock(f) / 3) * 3;
      if (!window.__fizzyPdpChildMap || !window.__fizzyPdpChildStock) return Infinity;
      var c = boxChildFor(f);
      if (!c) return Infinity;
      var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9+]/g, ''); };
      for (var sk in window.__fizzyPdpChildStock) {
        if (norm(sk) === norm(c.option)) {
          var n = Number(window.__fizzyPdpChildStock[sk]);
          return isNaN(n) ? Infinity : Math.max(0, n);
        }
      }
      return Infinity;
    }

    var fields = hero.querySelectorAll('.flavor-field');
    var eyebrowFlavor = document.getElementById('eyebrowFlavor');
    var flavorNote = document.getElementById('flavorNote');
    var heroSlide = document.getElementById('heroSlide');
    var heroThumb = document.getElementById('heroThumb');
    // Flavor switcher — 4 colored dots + shared name label, anchored
    // to the bottom-right of the visualizer (.pdp-flavor-overlay).
    var previewPills = document.querySelectorAll('.pdp-flavor-overlay .pfo-dot');
    var pfoName = document.getElementById('pfoName');
    var current = 'bc';
    // Ensure body carries the initial flavor class so the trust ticker
    // (and any other body.flavor-* selectors) tint correctly on first paint.
    document.body.classList.add('flavor-bc');
    var animating = false;

    // ── flavor crossfade ──
    // Helper: mirror the selected flavor class onto <body> so siblings of
    // the hero (e.g. the trust ticker section below) can react to it.
    function setBodyFlavor(f) {
      var body = document.body;
      body.classList.remove('flavor-bc', 'flavor-sl', 'flavor-wm', 'flavor-ob');
      body.classList.add('flavor-' + f);
    }

    // "Tastes like" copy lives inside the .pdp-flavor-overlay pill at the
    // top of the buy box (under the H1). The pill stacks the flavor name
    // and the description on two lines. setTagline(f) is called from
    // swapTo so the line tracks the active flavor without us having to
    // wire a second source of truth. Source text comes from each .opt's
    // data-desc attribute in the flavor picker.
    var pfoTaste = document.getElementById('pfoTaste');
    function setTagline(f) {
      if (!pfoTaste) return;
      var src = document.querySelector('.flavor-picker .opt[data-f="' + f + '"]');
      if (!src) return;
      var desc = src.getAttribute('data-desc') || '';
      if (pfoTaste.textContent === desc) return;
      // Match the .pfo-name crossfade so the two lines feel like one
      // unit when the flavor changes. The 280ms aligns to the CSS
      // transition duration so the text swap lands exactly at opacity 0.
      pfoTaste.classList.add('fading');
      setTimeout(function () {
        pfoTaste.textContent = desc;
        pfoTaste.classList.remove('fading');
      }, 280);
    }

    var settleTimer = 0;
    function swapTo(f) {
      /* No `animating` gate (Sam 2026-08-31: "a bit of a delay when I try to
         toggle through flavors") — it silently dropped every tap inside the
         previous swap's 950ms crossfade. Swaps are interruptible now; the
         settle timer below is coalesced so only the last swap's tail runs. */
      if (f === current) return;
      // `current = f` runs at the TOP of the body now (was at the very
      // end). Any downstream helper that reads `current` (syncStickyAtc,
      // setTagline, etc.) needs the new flavor — having the assignment
      // at the bottom meant those reads were always one tick behind,
      // which left the sticky bar's active dot stuck on the previous
      // flavor on every swap.
      current = f;
      hero.classList.add('transitioning');
      // Body flavor class flips at the START so the ticker bg transition
      // runs in parallel with the hero crossfade rather than after it.
      setBodyFlavor(f);
      // The optimized surfaces transition their own colors immediately; they
      // must not wait for the legacy background crossfade to finish.
      if (hero.classList.contains('pdp-purchase-optimized')) {
        hero.classList.remove('flavor-bc', 'flavor-sl', 'flavor-wm', 'flavor-ob');
        hero.classList.add('flavor-' + f);
      }
      // Sync the "Tastes like" line under the flavor grid to the new flavor.
      setTagline(f);
      // Layered crossfade on .flavor-field — the smooth 900ms transition.
      // (Direct .pdp-hero.flavor-* class is updated at end of transition so
      // there's no instant background "jump" before the fade completes.)
      fields.forEach(function (el) { el.classList.toggle('active', el.dataset.f === f); });
      if (eyebrowFlavor) {
        eyebrowFlavor.classList.add('fading');
        setTimeout(function () {
          eyebrowFlavor.textContent = FLAV[f].name;
          eyebrowFlavor.classList.remove('fading');
        }, 300);
      }
      if (pfoName) {
        // Swap at 280ms to match the .pfo-name CSS transition — the text
        // changes exactly when opacity reaches 0, then fades + lifts back
        // into place. Same timing used for .pfo-taste below.
        pfoName.classList.add('fading');
        setTimeout(function () {
          pfoName.textContent = FLAV[f].name;
          pfoName.classList.remove('fading');
        }, 280);
      }
      if (flavorNote) {
        flavorNote.classList.add('fading');
        setTimeout(function () {
          flavorNote.textContent = FLAV[f].taste;
          flavorNote.classList.remove('fading');
        }, 300);
      }
      if (heroSlide) heroSlide.dataset.f = f;
      // (thumb image swap moved into applyFlavorVideo — no more inline
      // gradient bg here since the thumb now always shows a pouch PNG.)
      // sync the flavor-preview pills (under the title) to the new flavor
      if (previewPills && previewPills.length) {
        previewPills.forEach(function (p) { p.classList.toggle('active', p.dataset.f === f); });
      }
      applyFlavorVideo(f);
      applyFlavorDrinkImage(f);
      applyFlavorLifestyle2Image(f);
      applyFlavorLifestyleImage(f);
      applyFlavorClinicalImage(f);
      applyFlavorIncludedImage(f);
      applyFlavorSfpImage(f);
      applyFlavorGround(f);
      // Update the sticky-bar pouch thumb to the new active flavor.
      // (Plan label + ATC text don't change on flavor swap, only the
      // thumb — but syncStickyAtc handles all three idempotently.)
      if (typeof syncStickyAtc === 'function') syncStickyAtc();
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        // After the crossfade completes, sync the direct .pdp-hero flavor
        // class so the underlying background matches for the next interaction.
        hero.classList.remove('flavor-bc', 'flavor-sl', 'flavor-wm', 'flavor-ob');
        hero.classList.add('flavor-' + f);
        hero.classList.remove('transitioning');
        animating = false;
      }, 950);
      // (current = f was hoisted to the top of this function — see comment there.)
    }

    // ── hero video state ──
    var heroVideo = document.getElementById('heroVideo');
    var heroVideoToggle = document.getElementById('heroVideoToggle');
    var heroSlide = document.getElementById('heroSlide');
    var userPausedHero = true;

    // Product-image poster: the flavor's pouch shows under the hero video while
    // that video loads / swaps, so sifting through flavors never shows a blank
    // frame (Sam 2026-06-16). The cover-fit video fades in over it on .video-ready.
    function setHeroPoster(f) {
      var poster = document.getElementById('heroPoster');
      if (!poster) return;
      var pouch = document.querySelector('.flavor-picker .opt[data-f="' + f + '"] .opt-pouch');
      // Gallery posters need the original resolution; picker/thumb images stay small.
      var heroImages = isStickPlan() && stickData().heroImages;
      var source = (heroImages && heroImages[f]) || (pouch && pouch.src);
      if (source && poster.getAttribute('src') !== source) poster.src = source;
      if (FLAV[f]) poster.alt = 'FizzyFocus ' + FLAV[f].name + (isStickPlan() ? ' stick' : ' pouch');
    }
    function setHeroThumb(f) {
      var thumbImg = document.getElementById('heroThumbImg');
      var pouch = document.querySelector('.flavor-picker .opt[data-f="' + f + '"] .opt-pouch');
      if (thumbImg && pouch && thumbImg.src !== pouch.src) thumbImg.src = pouch.src;
    }
    function attachHeroReady(videoEl) {
      if (!videoEl || !heroSlide) return;
      // Reveal on every playback, including resume after showing the pouch.
      var reveal = function () {
        if (videoEl !== heroVideo || videoEl.paused) return;
        heroSlide.classList.add('video-ready');
      };
      videoEl.addEventListener('playing', reveal);
      if (!videoEl.paused && videoEl.readyState >= 2) reveal();
    }
    if (heroVideo) attachHeroReady(heroVideo);

    function syncHeroToggleUI() {
      if (!heroVideoToggle || !heroVideo) return;
      var paused = heroVideo.paused;
      if (paused && heroSlide) heroSlide.classList.remove('video-ready');
      heroVideoToggle.classList.toggle('paused', paused);
      heroVideoToggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    if (heroVideoToggle && heroVideo) {
      heroVideoToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (heroVideo.paused) {
          userPausedHero = false;
          heroVideo.play().catch(function () {});
        } else {
          userPausedHero = true;
          heroVideo.pause();
        }
        syncHeroToggleUI();
      });
      heroVideo.addEventListener('play', syncHeroToggleUI);
      heroVideo.addEventListener('pause', syncHeroToggleUI);
    }

    // ── per-flavor video swap (with fade-out → swap → fade-in) ──
    // Removing .has-video fades the current video to opacity 0 over 600ms.
    // We swap src mid-fade and let .has-video re-add to fade in the new one.
    // Swap the carousel slide 1 "drink benefits" image AND its matching
    // thumbnail to the version for the currently-previewed flavor.
    // Decoded async + opacity-faded so swaps are clean even on slower
    // connections.
    var drinkBenefitsImg = document.getElementById('drinkBenefitsImg');
    var drinkBenefitsThumbImg = document.getElementById('drinkBenefitsThumbImg');
    function applyFlavorDrinkImage(f) {
      if (!DRINK_BENEFITS_IMG[f]) return;
      var nextSrc = DRINK_BENEFITS_IMG[f];
      // Thumb uses the same source — Shopify CDN width param could be
      // smaller for the thumbnail but the browser caches the larger one
      // anyway, so use the same URL.
      if (drinkBenefitsThumbImg) drinkBenefitsThumbImg.src = nextSrc;
      if (!drinkBenefitsImg) return;
      if (drinkBenefitsImg.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        drinkBenefitsImg.style.opacity = '0';
        requestAnimationFrame(function () {
          drinkBenefitsImg.src = nextSrc;
          requestAnimationFrame(function () {
            drinkBenefitsImg.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Slide — flavor-aware lifestyle image. Same swap strategy as
    // applyFlavorDrinkImage above: preload the next src, fade the
    // current <img> to 0, swap src, fade back. Thumb at
    // #lifestyleThumbImg mirrors the main slide's source so the row
    // beneath the carousel updates in lockstep.
    var lifestyleImg = document.getElementById('lifestyleImg');
    var lifestyleThumbImg = document.getElementById('lifestyleThumbImg');
    FLAVOR_LIFESTYLE_IMG = groundMap(lifestyleImg) || FLAVOR_LIFESTYLE_IMG;
    function applyFlavorLifestyleImage(f) {
      if (!FLAVOR_LIFESTYLE_IMG[f]) return;
      var nextSrc = FLAVOR_LIFESTYLE_IMG[f];
      if (lifestyleThumbImg) lifestyleThumbImg.src = nextSrc;
      if (!lifestyleImg) return;
      if (lifestyleImg.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        if (current !== f) return; // a later preview won; don't show this late image
        lifestyleImg.style.opacity = '0';
        requestAnimationFrame(function () {
          lifestyleImg.src = nextSrc;
          requestAnimationFrame(function () {
            lifestyleImg.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Slide — second flavor-aware lifestyle image. Identical swap
    // pattern to applyFlavorLifestyleImage; separate handles so the two
    // lifestyle slides update independently on flavor change.
    var lifestyleImg2 = document.getElementById('lifestyleImg2');
    var lifestyleThumbImg2 = document.getElementById('lifestyleThumbImg2');
    function applyFlavorLifestyle2Image(f) {
      if (!FLAVOR_LIFESTYLE2_IMG[f]) return;
      var nextSrc = FLAVOR_LIFESTYLE2_IMG[f];
      if (lifestyleThumbImg2) lifestyleThumbImg2.src = nextSrc;
      if (!lifestyleImg2) return;
      if (lifestyleImg2.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        if (current !== f) return; // a later preview won; don't show this late image
        lifestyleImg2.style.opacity = '0';
        requestAnimationFrame(function () {
          lifestyleImg2.src = nextSrc;
          requestAnimationFrame(function () {
            lifestyleImg2.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Slide 5 — flavor-aware clinical-benefits backdrop. Same swap
    // strategy as applyFlavorDrinkImage above: preload the next src,
    // fade the current <img> to 0, swap src, fade back. Background
    // image is the only thing that changes between flavors — the
    // title and frosted cards are static HTML overlays.
    var clinicalBgImg = document.getElementById('clinicalBgImg');
    var clinicalThumbImg = document.getElementById('clinicalThumbImg');
    function applyFlavorClinicalImage(f) {
      if (!CLINICAL_BG_IMG[f]) return;
      var nextSrc = CLINICAL_BG_IMG[f];
      if (clinicalThumbImg) clinicalThumbImg.src = nextSrc;
      if (!clinicalBgImg) return;
      if (clinicalBgImg.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        clinicalBgImg.style.opacity = '0';
        requestAnimationFrame(function () {
          clinicalBgImg.src = nextSrc;
          requestAnimationFrame(function () {
            clinicalBgImg.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Slide 7 — flavor-aware "what's included" image. Same preload-
    // then-fade-swap strategy as slides 1 + 4 above. Background of
    // the slide itself is paper-cream (hardcoded inline in the
    // section markup); only the product shot swaps per flavor.
    var includedImg = document.getElementById('includedImg');
    var includedThumbImg = document.getElementById('includedThumbImg');
    INCLUDED_IMG = groundMap(includedImg) || INCLUDED_IMG;
    function applyFlavorIncludedImage(f) {
      if (!INCLUDED_IMG[f]) return;
      var nextSrc = INCLUDED_IMG[f];
      if (includedThumbImg) includedThumbImg.src = nextSrc;
      if (!includedImg) return;
      if (includedImg.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        if (current !== f) return; // a later preview won; don't show this late image
        includedImg.style.opacity = '0';
        requestAnimationFrame(function () {
          includedImg.src = nextSrc;
          requestAnimationFrame(function () {
            includedImg.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Slide 8 — flavor-aware Supplement Facts image. Same preload-
    // then-fade-swap pattern as the included slide above.
    var sfpImg = document.getElementById('sfpImg');
    var sfpThumbImg = document.getElementById('sfpThumbImg');
    function applyFlavorSfpImage(f) {
      if (!SFP_IMG[f]) return;
      var nextSrc = SFP_IMG[f];
      if (sfpThumbImg) sfpThumbImg.src = nextSrc;
      if (!sfpImg) return;
      if (sfpImg.src === nextSrc) return;
      var pre = new Image();
      pre.onload = function () {
        if (current !== f) return; // a later preview won; don't show this late image
        sfpImg.style.opacity = '0';
        requestAnimationFrame(function () {
          sfpImg.src = nextSrc;
          requestAnimationFrame(function () {
            sfpImg.style.opacity = '';
          });
        });
      };
      pre.src = nextSrc;
    }

    // Stills with no flavor artwork of their own (benefits, stimulant
    // comparison, nutrient forms) swap only their ground. Slides preload the
    // next file first so the swap never shows a blank frame; thumbnails swap
    // straight away. A late preload for a flavor no longer previewed is ignored.
    var groundImgs = Array.prototype.slice.call(document.querySelectorAll('img[data-flavor-ground]'));
    function applyFlavorGround(f) {
      groundImgs.forEach(function (img) {
        var map = groundMap(img);
        var nextSrc = map && map[f];
        if (!nextSrc || img.src === nextSrc) return;
        if (img.closest('.pdp-thumbs')) { img.src = nextSrc; return; }
        var pre = new Image();
        pre.onload = function () { if (current === f) img.src = nextSrc; };
        pre.src = nextSrc;
      });
    }

    function applyFlavorVideo(f) {
      if (!heroVideo || !heroSlide) return;
      var stageEl = document.getElementById('pdpStage');
      var src = FLAVOR_VIDEO[f];
      setHeroPoster(f);

      if (src) {
        // Preserve the shopper’s choice when the same flavor is already loaded.
        if (heroVideo.dataset.src === src && heroSlide.classList.contains('has-video')) {
          if (!userPausedHero && heroSlide.classList.contains('active')) {
            heroVideo.play().catch(function () {});
          } else { heroVideo.pause(); }
          syncHeroToggleUI();
          return;
        }

        // Replace the flavor video while preserving the shopper's playback
        // choice. The matching pouch stays visible until the new video plays.
        var oldVideo = heroVideo;
        oldVideo.pause();
        var newVideo = document.createElement('video');
        newVideo.id = 'heroVideo';
        newVideo.src = src;
        newVideo.dataset.src = src;
        newVideo.muted = true;
        newVideo.loop = true;
        newVideo.playsInline = true;
        newVideo.preload = 'none';
        newVideo.autoplay = false;
        newVideo.addEventListener('play', syncHeroToggleUI);
        newVideo.addEventListener('pause', syncHeroToggleUI);
        oldVideo.parentNode.replaceChild(newVideo, oldVideo);
        heroVideo = newVideo;
        // Reveal only when this flavor starts playing, not while it buffers.
        if (heroSlide) heroSlide.classList.remove('video-ready');
        attachHeroReady(newVideo);
        if (!userPausedHero && heroSlide.classList.contains('active')) {
          heroVideo.play().catch(function () { syncHeroToggleUI(); });
        }
        if (!heroSlide.classList.contains('has-video')) {
          heroSlide.classList.add('has-video');
        }
        if (stageEl && heroSlide.classList.contains('active')) {
          stageEl.classList.add('show-video-toggle');
        }
        syncHeroToggleUI();
      } else {
        // No video for this flavor — pause and revert to fallback image
        heroSlide.classList.remove('has-video');
        if (stageEl) stageEl.classList.remove('show-video-toggle');
        try { heroVideo.pause(); } catch (_) {}
      }
      // Thumbnail is now a static pouch <img> regardless of whether
      // this flavor has a hero video — we no longer mirror the video
      // into the thumb (which doubled the decoder workload). Pull the
      // pouch URL straight from the matching flavor-picker tile so
      // asset paths aren't duplicated in JS.
      setHeroThumb(f);
    }

    // ── gallery carousel (free scroll + thumb sync) ──
    var stage = document.getElementById('pdpStage');
    var track = document.getElementById('pdpTrack');
    if (stage && track) {
      var slides = track.querySelectorAll('.slide');
      var thumbsEl = document.getElementById('pdpThumbs');
      var thumbs = thumbsEl ? thumbsEl.querySelectorAll('.t') : [];
      var counter = document.getElementById('pdpCounter');
      var prevBtn = stage.querySelector('.arrow.prev');
      var nextBtn = stage.querySelector('.arrow.next');
      var slideIdx = 0;

      function setActive(i) {
        var total = slides.length;
        slideIdx = Math.max(0, Math.min(total - 1, i));
        thumbs.forEach(function (t, ix) {
          t.classList.toggle('active', ix === slideIdx);
          t.setAttribute('aria-pressed', ix === slideIdx ? 'true' : 'false');
        });
        slides.forEach(function (s, ix) { s.classList.toggle('active', ix === slideIdx); });
        if (counter) counter.textContent = (slideIdx + 1) + ' / ' + total;

        // play/pause hero video based on whether the product-video slide is active
        if (heroVideo && heroSlide && heroSlide.classList.contains('has-video')) {
          if (slides[slideIdx] === heroSlide) {
            if (!userPausedHero) heroVideo.play().catch(function () {});
          } else {
            heroVideo.pause();
          }
        }
        // show pause/play toggle only on hero slide when a video is loaded
        stage.classList.toggle(
          'show-video-toggle',
          slides[slideIdx] === heroSlide && heroSlide && heroSlide.classList.contains('has-video')
        );
        // flavor preview pills are tied to the hero/product showcase slot —
        // hidden when the user has swiped to any marketing-still slide.
        stage.classList.toggle('on-hero-slide', slides[slideIdx] === heroSlide);
        // (Marketing-slide BC indigo lock removed — the section bg now
        // stays in the active flavor color across all carousel slides.)
        syncHeroToggleUI();

        var activeThumb = thumbs[slideIdx];
        var pointerDriven = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        var keyboardInThumbs = thumbsEl && thumbsEl.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        if (activeThumb && thumbsEl && (!pointerDriven || thumbsEl.matches(':hover') || keyboardInThumbs)) {
          var tr = activeThumb.getBoundingClientRect();
          var cr = thumbsEl.getBoundingClientRect();
          /* Horizontal mode (default) — keep the active thumb in
             view by adjusting scrollLeft. Vertical mode (≥1500px)
             does the same on scrollTop. Sam 2026-06-01: as the user
             swipes the carousel, the strip auto-scrolls so the
             active slide's indicator is always visible. */
          var isVertical = getComputedStyle(thumbsEl).flexDirection === 'column';
          if (isVertical) {
            if (tr.top < cr.top) thumbsEl.scrollTop += tr.top - cr.top - 8;
            else if (tr.bottom > cr.bottom) thumbsEl.scrollTop += tr.bottom - cr.bottom + 8;
          } else {
            if (tr.left < cr.left) thumbsEl.scrollLeft += tr.left - cr.left - 8;
            else if (tr.right > cr.right) thumbsEl.scrollLeft += tr.right - cr.right + 8;
          }
        }
      }

      // Arrows, arrow keys and thumbnails set the slide at once, then scroll the
      // track there. While that scroll is in flight the scroll handler must not
      // re-derive the slide from the passing position, or .on-hero-slide (and
      // the offer band keyed on it), the counter and the hero video flicker back
      // and forth (2026-10-01). The guard clears when the track arrives, on
      // scrollend, or after a fallback timeout that also re-syncs.
      var navTarget = null;
      var navTimer = null;
      var reduceNav = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      function syncToTrack() {
        var w = track.clientWidth;
        if (w === 0) return;
        var i = Math.round(track.scrollLeft / w);
        if (i !== slideIdx) setActive(i);
      }
      function endNav() {
        if (navTarget === null) return;
        navTarget = null;
        clearTimeout(navTimer);
        // Re-sync only once the track rests on a slide; if it is still moving,
        // the scroll handler takes over from here.
        var w = track.clientWidth;
        if (w > 0 && Math.abs(track.scrollLeft - Math.round(track.scrollLeft / w) * w) < 2) syncToTrack();
      }
      function goSlide(n) {
        var total = slides.length;
        var target = ((n % total) + total) % total;
        navTarget = target;
        clearTimeout(navTimer);
        navTimer = setTimeout(endNav, 1500);
        track.scrollTo({ left: target * track.clientWidth, behavior: reduceNav && reduceNav.matches ? 'auto' : 'smooth' });
        setActive(target);
      }

      var scrollRaf = null;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          if (navTarget !== null) {
            var w = track.clientWidth;
            if (w > 0 && Math.round(track.scrollLeft / w) === navTarget && Math.abs(track.scrollLeft - navTarget * w) < 2) endNav();
            return;
          }
          syncToTrack();
        });
      }, { passive: true });
      track.addEventListener('scrollend', endNav);
      // A drag takes over from any programmatic slide change.
      track.addEventListener('pointerdown', function () { navTarget = null; clearTimeout(navTimer); });

      if (thumbsEl) {
        // Trackpad gestures may remain latched to their original scroll target
        // after the pointer leaves. Never consume that wheel input in this rail.
        thumbsEl.addEventListener('wheel', function (e) {
          var rect = thumbsEl.getBoundingClientRect();
          var inside = e.clientX >= rect.left && e.clientX < rect.right && e.clientY >= rect.top && e.clientY < rect.bottom;
          if (!inside && e.cancelable) e.preventDefault();
        }, { passive: false });
        thumbsEl.addEventListener('click', function (e) {
          var t = e.target.closest('.t');
          if (!t || !thumbsEl.contains(t)) return;
          var i = parseInt(t.dataset.i, 10);
          if (Number.isFinite(i)) goSlide(i);
        });
      }

      /* Vertical thumb strip (≥1500px) — keep max-height locked to
         the stage's actual rendered height so the strip never
         extends past the carousel. Pure CSS can't read another
         element's computed size, so a ResizeObserver handles it.
         Sam 2026-06-01. */
      /* Thumbnails are always a horizontal row below the gallery now
         (vertical strip removed 2026-06-12) — clear any stale inline
         max-height the old vertical-strip sync may have left behind. */
      if (thumbsEl) thumbsEl.style.maxHeight = '';
      if (prevBtn) prevBtn.addEventListener('click', function () { goSlide(slideIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goSlide(slideIdx + 1); });

      stage.tabIndex = 0;
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { goSlide(slideIdx - 1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { goSlide(slideIdx + 1); e.preventDefault(); }
      });

      // drag-to-scroll on the main stage
      var tD = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.target.closest('.arrow')) return;
        tD = { x: e.clientX, left: track.scrollLeft, moved: 0 };
        track.setPointerCapture(e.pointerId);
        track.classList.add('dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!tD) return;
        var dx = e.clientX - tD.x;
        tD.moved = Math.max(tD.moved, Math.abs(dx));
        track.scrollLeft = tD.left - dx;
      });
      function endTD() {
        if (!tD) return;
        track.classList.remove('dragging');
        var w = track.clientWidth;
        if (w > 0) {
          var i = Math.round(track.scrollLeft / w);
          track.scrollTo({ left: i * w, behavior: 'smooth' });
        }
        tD = null;
      }
      track.addEventListener('pointerup', endTD);
      track.addEventListener('pointercancel', endTD);

      setActive(0);
    }

    // Initial flavor video — ensures JS state matches the DOM-rendered slide 0
    applyFlavorVideo(current);

    // ── BUNDLE BUILDER ──
    function required() {
      if (isStickPlan()) return stickSize();
      var months = PLAN_MONTHS[state.plan] || 1;
      /* Pouches = months × servings/day (8–13 = 1, 14+ = 2). */
      var ageMult = state.age === '14+' ? 2 : 1;
      return months * ageMult;
    }
    function selectedCount() {
      return state.qty.bc + state.qty.sl + state.qty.wm + state.qty.ob;
    }

    // Quantity edits stay within the plan the shopper explicitly selected.
    function canAddFlavor(f) {
      var step = quantityStep();
      return selectedCount() + step <= required() && tierPrice(state.plan).available &&
        flavorAvail(f) && state.qty[f] + step <= flavorStock(f);
    }
    function quantityChanged() {
      renderBundle();
    }

    // Re-render the tier card prices (.was, .price, .save) and the
    // "Buy once" link price when state.age changes. Each .tier
    // element has a data-plan attribute so we can look up the matching
    // from live variant metadata. Called on initial render and on every age
    // toggle (see age handler further down).
    var optimizedPurchase = hero.classList.contains('pdp-purchase-optimized');
    var purchaseBusy = false;

    function renderStickSupply() {
      hero.querySelectorAll('[data-stick-quantity]').forEach(function (option) {
        var quantity = Number(option.dataset.stickQuantity);
        var available = stickPrice(quantity).available;
        var selected = quantity === stickSize();
        option.classList.toggle('selected', selected);
        option.setAttribute('aria-checked', selected ? 'true' : 'false');
        option.setAttribute('aria-disabled', available ? 'false' : 'true');
        option.setAttribute('aria-label', quantity + ' sticks' + (available ? '' : ', unavailable'));
        option.disabled = !available || purchaseBusy;
        option.tabIndex = selected && available ? 0 : -1;
      });
      hero.querySelectorAll('[data-stick-supply-options]').forEach(function (group) {
        // Keep one available choice reachable if the selected size is unavailable.
        if (!group.querySelector('[tabindex="0"]')) {
          var first = group.querySelector('[data-stick-quantity]:not(:disabled)');
          if (first) first.tabIndex = 0;
        }
      });
      hero.querySelectorAll('[data-stick-delivery]').forEach(function (label) {
        label.textContent = 'Delivered every ' + stickDays() + ' days';
      });
    }

    function resolveStickEntryQuantity() {
      // Let shoppers enter through an available size without changing an
      // already selected stick bundle or a valid remembered quantity.
      if (isStickPlan() || stickPrice().available) return;
      var available = [15, 30, 60].find(function (quantity) { return stickPrice(quantity).available; });
      if (available) state.stickQuantity = available;
    }

    function renderTierPrices() {
      resolveStickEntryQuantity();
      renderStickSupply();
      var offerActive = octoberOfferActive();
      hero.classList.toggle('oct-active', offerActive);
      /* Price + struck compare-at per tier, for the selected age. */
      var tiers = document.querySelectorAll('.tier[data-plan]');
      tiers.forEach(function (tier) {
        var plan = tier.dataset.plan;
        if (!plan) return;
        var p = tierPrice(plan);
        var offerBadge = tier.querySelector('.oct-price-badge');
        if (offerBadge) offerBadge.hidden = !(!isStickPlan(plan) && p.available && p.was > p.price); // First-box price label on intro-priced pouch cards
        var monthCount = PLAN_MONTHS[plan] || 1;
        var pouchCount = monthCount * (state.age === '14+' ? 2 : 1);
        var servingCount = isStickPlan(plan) ? stickSize() : pouchCount * 30;
        var serving = tier.querySelector('[data-serving-price]');
        if (serving) {
          var showServing = p.available && p.price > 0 && servingCount > 0;
          serving.hidden = !showServing;
          serving.style.display = showServing ? '' : 'none';
          serving.textContent = showServing ? money(p.price / servingCount, true) + '/serving' : '';
        }
        if (isStickPlan(plan)) {
          var stickPriceEl = tier.querySelector('.price');
          if (stickPriceEl) stickPriceEl.textContent = money(p.price);
          var stickWasEl = tier.querySelector('.was');
          if (stickWasEl) { stickWasEl.textContent = money(p.was); stickWasEl.hidden = !p.was; stickWasEl.style.display = p.was ? '' : 'none'; }
          var sizeEl = tier.querySelector('[data-stick-size]');
          if (sizeEl) sizeEl.textContent = stickSize() + ' sticks';
          tier.setAttribute('aria-disabled', p.available ? 'false' : 'true');
          return;
        }
        var pouchesEl = tier.querySelector('[data-plan-pouches]');
        if (pouchesEl) pouchesEl.textContent = pouchCount + (pouchCount === 1 ? ' pouch' : ' pouches');
        var wasEl = tier.querySelector('.was');
        var priceEl = tier.querySelector('.price');
        var saveEl = tier.querySelector('.save');
        var chipEl = tier.querySelector('[data-save-chip]');
        if (priceEl) priceEl.textContent = money(p.price);
        tier.setAttribute('aria-disabled', p.available ? 'false' : 'true');
        // Compare pouches with the same quantity bought once. This is display-only:
        // p.was remains the regular subscription price for offer and renewal logic.
        var onceUnit = Number(window.__fizzyPdpBoxOncePrice);
        var COMPARE_TO_SUB_LIST = true; // false = strike through the one-time price ($80/$240) instead of the subscription list price ($59/$177)
        var onceValue = COMPARE_TO_SUB_LIST ? p.was : Math.round(onceUnit * pouchCount * 100) / 100;
        var showOnceValue = p.available && (COMPARE_TO_SUB_LIST || (Number.isFinite(onceUnit) && onceUnit > 0)) &&
          Number.isFinite(onceValue) && onceValue > p.price;
        var priceRail = tier.querySelector('.tier-price');
        if (priceRail) priceRail.classList.toggle('has-once-value', !!(wasEl && showOnceValue));
        if (wasEl) {
          wasEl.classList.add('pdp-once-value');
          wasEl.textContent = '';
          if (showOnceValue) {
            var onceLabel = document.createElement('span');
            onceLabel.className = 'visually-hidden';
            onceLabel.textContent = COMPARE_TO_SUB_LIST ? 'Regular price ' : 'One-time price ';
            var onceAmount = document.createElement('span');
            onceAmount.className = 'pdp-once-value-amount';
            onceAmount.textContent = money(onceValue);
            wasEl.appendChild(onceLabel);
            wasEl.appendChild(onceAmount);
          }
          wasEl.hidden = !showOnceValue;
          wasEl.style.display = showOnceValue ? '' : 'none';
        }
        if (saveEl) saveEl.textContent = 'Save ' + money(p.save_amt) + ' · ' + p.save_pct + '%';
        if (chipEl) { chipEl.textContent = 'SAVE ' + p.save_pct + '%'; chipEl.style.display = p.save_pct ? '' : 'none'; }
      });
      document.querySelectorAll('[data-once-count]').forEach(function (el) {
        el.textContent = '1 pouch';
      });
      document.querySelectorAll('[data-once-serving]').forEach(function (el) {
        var once = Number(window.__fizzyPdpBoxOncePrice);
        el.textContent = once > 0 ? ' · ' + money(once / 30, true) + '/serving' : '';
      });
      var boPrice = document.querySelector('.buy-once-link .bo-price');
      if (boPrice) {
        if (window.__fizzyPdpChildMap) {
          // Box mode buy-once sells the child pouch DIRECTLY (no box, no
          // _pv). The one-pouch shortcut always shows the unit price.
          // Unit price comes from the
          // section's box_once_price setting via __fizzyPdpBoxOncePrice.
          var boUnit = Number(window.__fizzyPdpBoxOncePrice);
          boPrice.textContent = boUnit > 0 ? money(boUnit) : 'price at checkout';
        } else {
          var once = priceFor('8-13', 'once');
          boPrice.textContent = money(once.price);
        }
      }
    }
    document.addEventListener('fizzy:october-expired', function() {
      renderTierPrices();
      renderBundle();
      syncStickyAtc();
    });
    // Render once on init so the page matches state.age on first paint.
    renderTierPrices();

    // Deep-link: ?flavor=bc|sl|wm|ob pre-selects (previews) that flavor on load
    // — used by the home "Best Sellers" Learn more links. Sam 2026-06-09.
    (function () {
      var fp = (new URLSearchParams(window.location.search)).get('flavor');
      if (fp && /^(bc|sl|wm|ob)$/.test(fp) && fp !== current) { swapTo(fp); }
    })();

    var bundleCounter = document.getElementById('bundleCounter');
    var bundleProgress = document.getElementById('bundleProgress');
    var addBtn = document.getElementById('addToCartBtn');

    // ── Sticky ATC element refs + sync ──
    // Sync mirrors three things from the main buy box onto the sticky
    // bar: the ATC's text + disabled state, the active plan label,
    // and the pouch thumbnail. Called from renderBundle (whenever
    // bundle/plan state changes) and from swapTo (whenever the active
    // flavor changes), so the sticky bar never falls out of sync.
    var stickyAtc        = document.getElementById('stickyAtc');
    var stickyAtcBtn     = document.getElementById('stickyAtcBtn');
    var stickyAtcThumb   = document.getElementById('stickyAtcThumb');
    var stickyAtcPlan    = document.getElementById('stickyAtcPlan');
    var stickyPlanTimer = 0;
    var stickyAtcPrice   = document.getElementById('stickyAtcPrice');
    var stickyAtcWas     = document.getElementById('stickyAtcWas');
    var stickyAtcFlavorName = document.getElementById('stickyAtcFlavorName');
    var stickyAtcDots    = document.querySelectorAll('#stickyAtcFlavors .sa-dot');
    // Sticky button is a single-state "Buy now" scroll shortcut on
    // every viewport — it never mirrors the main ATC's validation
    // state. Tapping it smooth-scrolls the user up to the buy box
    // where they can configure flavor + plan and then commit via the
    // real ATC. Keeps the sticky bar as a "get me back to where I can
    // buy" affordance rather than a parallel commit path.
    /* Which side of the buy box the reader is on: 'ahead' (buy box still below
       the fold), 'past' (scrolled beyond it), or null (buy box on screen, bar
       hidden). Declared out here because syncStickyAtc runs on every bundle and
       flavour change and would otherwise stamp the wrong label back on.
       Sam 2026-08-28. */
    var stickyMode = null;

    /* The button has never added to cart — it smooth-scrolls to the buy box.
       That was tolerable when the bar only appeared after you had already
       passed the real Add to Cart; now that it also greets you on the way
       down, a button reading "Add to Cart" that silently scrolls is a lie.
       Name the action in the ahead state. */
    /* Lowest daily cost for the selected age, using the plan-card prices. */
    function lowestPerDay() {
      var best = null;
      ['1m', '3m'].forEach(function (plan) {
        var p = tierPrice(plan);
        if (!p.available) return;
        var per = p.price / (PLAN_MONTHS[plan] * 30);
        if (!best || per < best.per) best = { per: per, plan: plan, price: p.price, days: PLAN_MONTHS[plan] * 30 };
      });
      return best;
    }

    function stickyLabelFor(mode) {
      if (optimizedPurchase) {
        if (purchaseBusy) return 'Adding…';
        var chosen = tierPrice(state.plan);
        if (!chosen.available) return 'Choose a plan &rarr;';
        var complete = selectedCount() === required() && required() > 0;
        return (complete ? 'Add to cart' : 'Choose flavors') + ' · ' + money(chosen.price) + ' &rarr;';
      }

      var offer = lowestPerDay();
      if (offer) return '<span>From ' + money(offer.per, true) + '/day &rarr;</span>';
      return mode === 'ahead' ? 'Choose your plan &rarr;' : 'Select your plan &rarr;';
    }

    function renderPlanAvailability() {
      var el = document.querySelector('[data-plan-notice]');
      if (!el) return;
      var available = tierPrice(state.plan).available;
      el.hidden = available;
      el.textContent = available ? '' : 'This plan is currently unavailable. Choose another age or plan.';
    }

    function syncStickyAtc() {
      if (!stickyAtcBtn) return;
      stickyAtcBtn.disabled = optimizedPurchase && purchaseBusy;
      stickyAtcBtn.innerHTML = stickyLabelFor(stickyMode);
      if (stickyAtcPlan) {
        var planLabel = isStickPlan() ? stickPlanLabel() : PLAN_PROPERTY[state.plan] || PLAN_LABELS[state.plan] || '';
        clearTimeout(stickyPlanTimer);
        if (stickyAtcPlan.textContent !== planLabel) {
          stickyAtcPlan.classList.add('fading');
          stickyPlanTimer = setTimeout(function () {
            stickyAtcPlan.textContent = planLabel;
            stickyAtcPlan.classList.remove('fading');
          }, 180);
        } else { stickyAtcPlan.classList.remove('fading'); }
      }
      /* Price + compare-at — sourced from priceFor() (live variant metadata) so
         the sticky stays in lockstep with the active age tier. */
      var p = tierPrice(state.plan);
      if (p && stickyAtcPrice) stickyAtcPrice.textContent = money(p.price);
      if (p && stickyAtcWas) { stickyAtcWas.textContent = money(p.was); stickyAtcWas.hidden = !p.was; stickyAtcWas.style.display = p.was ? '' : 'none'; }
      /* Active flavor name caption — pulled from the FLAV catalog so
         it stays in sync with the previewed flavor (the source of
         truth for the hero swap). */
      if (stickyAtcFlavorName && FLAV[current]) {
        stickyAtcFlavorName.textContent = FLAV[current].name;
      }
      if (stickyAtcThumb) {
        var pouchEl = document.querySelector(
          '.flavor-picker .opt[data-f="' + current + '"] .opt-pouch'
        );
        if (pouchEl && stickyAtcThumb.src !== pouchEl.src) {
          stickyAtcThumb.src = pouchEl.src;
        }
      }
      // Mirror the active flavor onto the sticky's dot row so the
      // paper ring follows whichever flavor is being previewed.
      if (stickyAtcDots && stickyAtcDots.length) {
        stickyAtcDots.forEach(function (d) {
          d.classList.toggle('active', d.dataset.f === current);
          /* The swatches carry no state for assistive tech otherwise — selection
             was a class alone — and a sold-out swatch would swap the hero and
             then silently skip the add. Both are announced now, and the
             :disabled styling that already existed becomes reachable. */
          /* `current`, not `f`. An earlier pass wrote `f` here, which does not
             exist in this scope: syncStickyAtc() takes no argument. The
             ReferenceError aborted init() partway — after the ATC and picker
             handlers wired up but BEFORE the sticky-ATC mount, the member-gifts
             modal and the accordion — so the sticky bar never appeared and
             [data-mg-open] did nothing. Sam 2026-08-29. */
          var on = d.getAttribute('data-f') === current;
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
          var avail = typeof flavorAvail === 'function' ? flavorAvail(d.getAttribute('data-f')) : true;
          /* Sold out still PREVIEWS (Sam 2026-08-31): the swatch swaps the
             hero; only the add is blocked, by the click handler's own
             flavorAvail guard. `disabled` killed the click entirely, which
             dead-ended browsing whenever the whole lineup was out of stock. */
          d.disabled = false;
          d.classList.toggle('is-soldout', !avail);
          var nm = (FLAV[d.getAttribute('data-f')] || {}).name || d.getAttribute('data-f');
          d.setAttribute('aria-label', avail ? nm : nm + ', coming soon');
      });
      }
    }

    // Sticky swatches preview only; quantities belong to the picker steppers.
    if (stickyAtcDots && stickyAtcDots.length) {
      stickyAtcDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var f = dot.dataset.f;
          if (f) swapTo(f);
        });
      });
    }

    // All amounts come from the same live allocation resolver as Add to cart.
    function renderPurchaseTerms() {
      var p = tierPrice(state.plan);
      var terms = hero.querySelector('[data-purchase-terms]');
      var renewal = hero.querySelector('[data-purchase-renewal]');
      var valid = p.available && p.price > 0;
      if (terms) terms.hidden = !valid;
      if (renewal) renewal.textContent = valid && !isStickPlan() ? subscriptionRenewalText(state.plan) : '';
    }

    function renderBundle() {
      // Drop any flavor that's out of stock for the current age + plan before
      // counting, so a sold-out flavor can't keep the bundle "complete" —
      // and clamp each flavor to its remaining child stock (1 left = max 1).
      ['bc', 'sl', 'wm', 'ob'].forEach(function (f) {
        if (state.qty[f] && !flavorAvail(f)) state.qty[f] = 0;
        var cap = flavorStock(f);
        if (state.qty[f] > cap) state.qty[f] = cap;
      });
      var req = required();
      var cur = selectedCount();
      var remaining = req - cur;
      hero.classList.toggle('stick-mode', isStickPlan());
      hero.dataset.purchasePlan = state.plan;
      hero.dataset.stickDays = stickDays();
      hero.dataset.stickQuantity = stickSize();
      document.querySelectorAll('[data-stick-only]').forEach(function (el) { el.hidden = !isStickPlan(); });
      document.querySelectorAll('[data-stick-target]').forEach(function (el) { el.textContent = stickSize(); });
      document.querySelectorAll('[data-stick-renewal]').forEach(function (el) { el.textContent = stickRenewalText(); });
      document.querySelectorAll('.flavor-picker .opt-pouch').forEach(function (img) {
        if (!img.dataset.pouchSrc) { img.dataset.pouchSrc = img.getAttribute('src'); img.dataset.pouchAlt = img.alt; }
        var tile = img.closest('.opt'), f = tile && tile.dataset.f;
        var source = isStickPlan() && stickData().images ? stickData().images[f] : img.dataset.pouchSrc;
        if (source && img.getAttribute('src') !== source) img.src = source;
        img.alt = isStickPlan() ? (FLAV[f] || {}).name + ' FizzyFocus stick' : img.dataset.pouchAlt;
      });
      // A plan switch changes the format even before another flavor is previewed.
      setHeroPoster(current);
      setHeroThumb(current);
      document.querySelectorAll('.flavor-help-mobile').forEach(function (help) {
        help.textContent = isStickPlan() ? (cur === req ? 'Pack full. Remove 3 sticks to make room for another flavor.' : 'Tap a flavor or use + to add 3 sticks. Use Remove to take 3 out.') : req === 1
          ? 'Tap a flavor to choose or switch your pouch.'
          : cur === req
            ? 'Box full. Tap any flavor to preview it. Remove a pouch to make room.'
            : 'Tap a flavor to preview it and add a pouch. Use Remove to take one out.';
      });

      if (bundleCounter) {
        bundleCounter.innerHTML = '<b>' + cur + '</b> of <b>' + req + '</b> ' + (isStickPlan() ? 'sticks picked' : 'selected');
        bundleCounter.classList.toggle('complete', cur === req && req > 0);
      }

      if (bundleProgress) {
        var pct = req > 0 ? Math.min(1, cur / req) : 0;
        var fillEl = bundleProgress.querySelector('.fill');
        if (fillEl) {
          // transform: scaleX is GPU-composited — no layout/paint per
          // frame the way `width` would. Smooth on Safari even with
          // the header's backdrop-filter and ticker marquee running.
          fillEl.style.transform = 'scaleX(' + pct + ')';
        }
        bundleProgress.classList.toggle('complete', cur === req && req > 0);
      }

      document.querySelectorAll('.flavor-picker .opt').forEach(function (opt) {
        var f = opt.dataset.f;
        var q = state.qty[f];
        var soldOut = !flavorAvail(f);
        var stepper = opt.querySelector('.stepper');
        // Qty count lives between the +/- buttons inside the stepper now
        // (previously was a corner badge — moved inline for readability).
        var qtyEl = opt.querySelector('.stepper .qty');
        if (qtyEl) qtyEl.textContent = q;
        var flavorName = (FLAV[f] || {}).name || f;
        ['inc','dec'].forEach(function (action) {
          var button = stepper.querySelector('.' + action);
          button.setAttribute('aria-label', (action === 'inc' ? 'Add ' : 'Remove ') + (isStickPlan() ? '3 ' : '') + flavorName + (isStickPlan() ? ' sticks' : ''));
          var label = button.querySelector('.quantity-action');
          if (label) label.textContent = (action === 'inc' ? ' Add' : ' Remove') + (isStickPlan() ? ' 3' : '');
        });
        stepper.querySelector('.dec').disabled = q <= 0;
        var remove = opt.querySelector('.remove-btn');
        if (remove) { remove.disabled = q <= 0; remove.setAttribute('aria-label', 'Remove ' + (isStickPlan() ? '3 ' : 'one ') + flavorName + (isStickPlan() ? ' sticks' : '')); remove.textContent = isStickPlan() ? 'Remove 3' : 'Remove'; }
        stepper.querySelector('.inc').disabled = !canAddFlavor(f);
        opt.classList.toggle('soldout', soldOut);
        /* Sold-out was drawn only by a ::after label. Generated content is not
           reliably exposed to assistive tech and carries no accessible name, so
           the state was visual-only. State it on the tile as well.
           Sam 2026-08-29. */
        opt.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        var soName = (FLAV[f] || {}).name || f;
        opt.setAttribute('aria-label', soldOut ? soName + ', coming soon' : soName + ', ' + q + (isStickPlan() ? ' sticks in your pack' : ' in your box'));
        // Mobile-only corner badge mirrors the same count — it's
        // hidden via .has-qty (opacity 0/1) so the badge fades in
        // when the flavor enters the bundle and out when it leaves.
        var badgeEl = opt.querySelector('.opt-badge');
        if (badgeEl) badgeEl.textContent = q;
        opt.classList.toggle('selected', q > 0);
        opt.classList.toggle('has-qty', q > 0);
      });

      if (addBtn) {
        var p = tierPrice(state.plan);
        if (!p.available) {
          addBtn.disabled = true;
          addBtn.textContent = 'Plan unavailable';
        } else if (req === 0) {
          addBtn.disabled = true;
          addBtn.textContent = 'Select a plan';
        } else if (!exactSelection()) {
          addBtn.disabled = true;
          addBtn.textContent = isStickPlan() ? (remaining > 0 ? 'Choose ' + remaining + ' more sticks' : 'Choose exactly ' + req + ' sticks') : cur === 0 ? 'Choose your flavors' : remaining === 1
            ? 'Add 1 more pouch to continue'
            : 'Add ' + remaining + ' more pouches to continue';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart · ' + money(p.price);
        }
      }
      if (purchaseBusy && addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
      renderPurchaseTerms();
      renderPlanAvailability();
      // Mirror the latest ATC state to the sticky bar at the very end —
      // captures both the text/disabled changes above AND any state.plan
      // change that came in via the tier click handler.
      syncStickyAtc();
    }

    // Steppers change only the bundle quantity on every viewport.
    document.querySelectorAll('.flavor-picker .stepper').forEach(function (st) {
      var f = st.dataset.f;
      st.querySelector('.inc').addEventListener('click', function (e) {
        e.stopPropagation();
        if (!canAddFlavor(f)) return;
        state.qty[f] += quantityStep();
        quantityChanged();
      });
      st.querySelector('.dec').addEventListener('click', function (e) {
        e.stopPropagation();
        if (state.qty[f] <= 0) return;
        state.qty[f] = Math.max(0, state.qty[f] - quantityStep());
        quantityChanged();
      });
    });

    // Every card previews; a one-pouch plan switches directly to that flavor.
    document.querySelectorAll('.flavor-picker .opt').forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (e.target.closest('.stepper, .remove-btn')) return;
        var f = o.dataset.f;
        swapTo(f);
        if (purchaseBusy) return;
        if (required() === 1) {
          if (!tierPrice(state.plan).available || !flavorAvail(f) || flavorStock(f) < 1) return;
          Object.keys(state.qty).forEach(function (key) { state.qty[key] = key === f ? 1 : 0; });
          quantityChanged();
        } else if (window.matchMedia('(max-width: 820px)').matches && canAddFlavor(f)) {
          state.qty[f] += quantityStep();
          quantityChanged();
        }
      });
    });

    // Mobile-only Remove button — single-action equivalent of the
    // .stepper's [−] button. Decrement by 1, no-op when already at 0.
    // e.stopPropagation prevents the tile click from also firing
    // (which would add 1 back via the handler above).
    document.querySelectorAll('.flavor-picker .remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var f = btn.dataset.f;
        if (state.qty[f] <= 0) return;
        state.qty[f] = Math.max(0, state.qty[f] - quantityStep());
        quantityChanged();
      });
    });

    // Flavor preview pills under the H1 — same preview behavior, no bundle impact.
    previewPills.forEach(function (p) {
      p.addEventListener('click', function () {
        swapTo(p.dataset.f);
      });
    });

    // Deep link: ?variant=wm / ?flavor=watermelon (mobile-menu flavor links)
    // previews that flavor on load. Preview only — nothing added to the bundle.
    (function () {
      try {
        var q = new URLSearchParams(window.location.search);
        var raw = (q.get('flavor') || q.get('variant') || '').toLowerCase();
        if (!raw) return;
        var MAP = {
          bc: 'bc', sl: 'sl', wm: 'wm', ob: 'ob',
          'berry-cherry': 'bc', 'berrycherry': 'bc', 'berry': 'bc',
          'strawberry-lemonade': 'sl', 'strawberrylemonade': 'sl', 'strawberry': 'sl',
          'watermelon': 'wm', 'water-melon': 'wm',
          'orange-creamsicle': 'ob', 'orangecreamsicle': 'ob', 'orange': 'ob'
        };
        var f = MAP[raw];
        if (f) swapTo(f);
      } catch (e) {}
    })();

    /* Keeps a radiogroup's ARIA and roving tabindex in step with the .selected
       class, and gives it arrow-key operation. The age and plan pickers are
       divs with click listeners; marking them up as radios without this would
       announce a group nobody can move through. Added 2026-08-28. */
    function wireRadioGroup(nodes, onPick) {
      if (!nodes || !nodes.length) return;
      var list = Array.prototype.slice.call(nodes);
      function sync(chosen) {
        list.forEach(function (n) {
          var on = n === chosen;
          n.setAttribute('aria-checked', on ? 'true' : 'false');
          n.tabIndex = on ? 0 : -1;
        });
      }
      list.forEach(function (n, i) {
        n.addEventListener('keydown', function (e) {
          var k = e.key, step = 0;
          if (k === 'ArrowRight' || k === 'ArrowDown') step = 1;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') step = -1;
          else if (k === ' ' || k === 'Enter') { e.preventDefault(); n.click(); return; }
          else return;
          e.preventDefault();
          var next = list[(i + step + list.length) % list.length];
          var visited = 0;
          while (next.getAttribute('aria-disabled') === 'true' && visited++ < list.length) next = list[(list.indexOf(next) + step + list.length) % list.length];
          if (next.getAttribute('aria-disabled') !== 'true') { next.focus(); next.click(); }
        });
      });
      /* The click handlers already toggle .selected, so mirror from there
         rather than duplicating the selection logic. */
      list.forEach(function (n) {
        n.addEventListener('click', function () { if (purchaseBusy || n.getAttribute('aria-disabled') === 'true') return; sync(n); if (onPick) onPick(n); });
      });
      sync(list.filter(function (n) { return n.classList.contains('selected'); })[0] || list[0]);
    }

    // Plan tier selection — just toggle .selected and update state.
    var tiers = document.querySelectorAll('.tier');
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!tierPrice(t.dataset.plan).available || purchaseBusy) return;
        var wasStick = isStickPlan();
        tiers.forEach(function (x) { x.classList.toggle('selected', x === t); });
        state.plan = t.dataset.plan;
        if (wasStick !== isStickPlan()) resetFlavorCounts();
        trimToRequired();
        renderTierPrices();
        renderBundle();
      });
    });

    // Sample-pack button (inside the .pdp-flavor-overlay preview pill).
    /* Sample-kit clicks are handled site-wide by initSampleKitTriggers() in
       fizzy-header.js (Sam 2026-09-04) so every entry point behaves the same
       and the anchor's navigation is cancelled. The per-element binding that
       used to live here has been removed to avoid opening the form twice. */

    /* ── Age picker (single select) ──
       8–13 or 14+ (the adult dose). Drives required() pouches + tier
       pricing. Simplified back from the household picker 2026-06-03. */
    /* Display only: 14+ takes 2 servings/day, so each plan covers the same
       window with double the servings — show 60/120/180 instead of 30/60/90.
       The shipping cadence (every 30/60/90 days) is unchanged. */
    function renderServings() {
      var mult = state.age === '14+' ? 2 : 1;
      document.querySelectorAll('.tnote-srv').forEach(function (el) {
        var base = parseInt(el.dataset.srv, 10) || 0;
        el.textContent = base * mult;
      });
    }

    hero.querySelectorAll('[data-stick-supply-options]').forEach(function (group) {
      var options = group.querySelectorAll('[data-stick-quantity]');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          var quantity = Number(option.dataset.stickQuantity);
          if (purchaseBusy || !isStickPlan() || !stickPrice(quantity).available) return;
          state.stickQuantity = quantity;
          trimToRequired();
          renderTierPrices();
          renderBundle();
        });
      });
      wireRadioGroup(options);
    });

    wireRadioGroup(document.querySelectorAll('.plans .tier'));

    var ageOpts = document.querySelectorAll('.age-picker .opt');
    ageOpts.forEach(function (a) {
      a.addEventListener('click', function () {
        if (purchaseBusy) return;
        ageOpts.forEach(function (x) { x.classList.toggle('selected', x === a); });
        state.age = a.dataset.age;
        renderServings();
        renderTierPrices();
        trimToRequired();
        renderBundle();
      });
    });
    wireRadioGroup(ageOpts);
    renderServings();

    function trimToRequired() {
      var req = required();
      var cur = selectedCount();
      if (cur <= req) return;
      var step = quantityStep();
      while (cur > req) {
        var order = ['bc', 'sl', 'wm', 'ob']
          .filter(function (f) { return state.qty[f] >= step; })
          .sort(function (a, b) { return isStickPlan() ? state.qty[b] - state.qty[a] : state.qty[a] - state.qty[b]; });
        if (!order.length) break;
        state.qty[order[0]] -= step;
        cur -= step;
      }
    }

    if (addBtn) {
      // Plan → human-readable property string that lands in the cart drawer chip
      // (PLAN_PROPERTY hoisted to module scope above so syncStickyAtc
      // can read it too — see the top of init().)
      // Long-form flavor name written to line-item properties (drawer reads
      // this to pick the swatch + pouch image via FLAVOR_MAP).
      var FLAVOR_NAME = {
        bc: 'Berry Cherry',
        sl: 'Strawberry Lemonade',
        wm: 'Watermelon',
        ob: 'Orange Creamsicle'
      };
      // Canonical option strings for resolving the parent bundle variant.
      // Matching is whitespace/case-insensitive so the same code runs on the
      // dev store ("Watermelon") and production ("Water Melon"); the Flavor 1..N
      // line-item properties always use the STORE's exact option string, since
      // the production bundle app matches on them.
      var FLAVOR_OPTION = { bc: 'Berry Cherry', sl: 'Strawberry Lemonade', wm: 'Water Melon', ob: 'Orange Creamsicle' };
      var QTY_OPTION = { '1m': '1 Month Supply', '2m': '2 Month Supply', '3m': '3 Month Supply', 'once': 'Try It Once' };
      function normOpt(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9+]/g, ''); }
      function pdpVariant(flavorParam, age, plan) {
        if (isStickPlan(plan)) return stickVariant();
        var list = window.__fizzyPdpVariants || [];
        if (window.__fizzyPdpChildMap) {
          // Skio Classic Box product: ONE option ("Size"), values "1"/"2"/"3"…
          // The variant is the pouch COUNT; age/plan only decide which count —
          // and the AGE decides which box product's variants to search (8-13 =
          // rendered product, 14+ = the alt box emitted by the section).
          var months = plan === 'once' ? 1 : parseInt(plan, 10) || 1;
          var size = months * (age === '14+' ? 2 : 1);
          var boxList = boxDataFor(age).variants;
          for (var b = 0; b < boxList.length; b++) {
            if (String(boxList[b].option1).trim() === String(size)) return boxList[b];
          }
          return null;
        }
        var a = normOpt(age === '14+' ? 'Ages 14+' : 'Ages 8-13');
        var q = normOpt(QTY_OPTION[plan]);
        for (var i = 0; i < list.length; i++) {
          var v = list[i];
          if (normOpt(v.option1) === normOpt(FLAVOR_OPTION[flavorParam]) && normOpt(v.option2) === a && normOpt(v.option3) === q) {
            return v;
          }
        }
        return null;
      }
      // Box mode: the selling plan must MATCH the chosen tier's frequency
      // (1m→30 days, 2m→60, 3m→90) — Sam's rule 2026-08-15. The plan map is
      // emitted by the section from the box product's selling plan groups.
      function boxPlanFor(plan) {
        if (isStickPlan(plan)) return stickPlanId();
        return boxPlanIdFor(state.age, plan);
      }
      function storeFlavorOption(flavorParam) {
        if (isStickPlan()) { var stick = stickChildFor(flavorParam); return stick ? stick.option : null; }
        // Box mode: the store-exact flavor string lives on the CHILD product's
        // option (the parent has no flavor axis to read it from).
        if (window.__fizzyPdpChildMap) {
          var c = boxChildFor(flavorParam);
          if (c) return c.option;
        }
        var list = window.__fizzyPdpVariants || [], want = normOpt(FLAVOR_OPTION[flavorParam]);
        for (var i = 0; i < list.length; i++) { if (normOpt(list[i].option1) === want) return list[i].option1; }
        return FLAVOR_OPTION[flavorParam];
      }
      // Skio Static Box cart contract: one _pv<child-variant-gid> property per
      // chosen flavor, value = pouch count. Skio composes the box (and the $0
      // child order lines) from these. Size correctness is OUR job — Skio does
      // not validate at cart time (their support, 2026-08-14).
      function applyBoxProperties(properties, counts) {
        if (!window.__fizzyPdpChildMap && !isStickPlan()) return;
        for (var f in counts) {
          if (!counts[f]) continue;
          var c = isStickPlan() ? stickChildFor(f) : boxChildFor(f);
          if (c) properties['_pvgid://shopify/ProductVariant/' + c.id] = counts[f];
        }
      }
      function sellingPlanOf(v) { var a = v && v.selling_plan_allocations; return (a && a.length) ? a[0].selling_plan_id : null; }

      addBtn.addEventListener('click', function () {
        if (addBtn.disabled || purchaseBusy) return;
        if (!exactSelection() || !tierPrice(state.plan).available) { renderBundle(); return; }

        // Bundle contract: ONE line = the parent variant for the primary flavor
        // × age × plan, quantity 1, with Flavor 1..N properties (one per pouch
        // slot) + Age Range + the Skio selling_plan from the variant's allocation.
        // Matches the developer's fizzyiq-buy-box / live orders. The bundle app
        // expands this into the $0 child component pouches server-side.
        var units = [];
        ['bc', 'sl', 'wm', 'ob'].forEach(function (f) { for (var i = 0; i < state.qty[f]; i++) units.push(f); });
        if (!units.length) return;
        var variant = pdpVariant(units[0], state.age, state.plan);
        if (!variant) {
          console.error('[FizzyIQ ATC] no variant for', units[0], state.age, state.plan);
          return;
        }
        // Store-exact option strings (storeFlavorOption) so the same code runs on
        // dev ("Watermelon") and prod ("Water Melon"). In box mode the variant
        // option is the SIZE, so Age Range comes from the UI state instead.
        var properties = {};
        if (isStickPlan()) {
          properties._offer = 'stick15';
          properties['Bundle size'] = stickSize() + ' sticks';
        } else {
          properties['Age Range'] = window.__fizzyPdpChildMap ? ageLabel() : variant.option2;
        }
        units.forEach(function (f, i) { properties['Flavor ' + (i + 1)] = storeFlavorOption(f); });
        applyBoxProperties(properties, state.qty);
        var line = { id: variant.id, quantity: 1, properties: properties };
        var sp = (window.__fizzyPdpChildMap || isStickPlan()) ? boxPlanFor(state.plan) : sellingPlanOf(variant);
        if ((window.__fizzyPdpChildMap || isStickPlan()) && state.plan !== 'once' && !sp) {
          // A subscription tier without its matching frequency plan must NEVER
          // fall through to a one-time sale at the subscription price.
          console.error('[FizzyIQ ATC] no selling plan for tier', state.plan, '— box product is missing that frequency');
          addBtn.textContent = 'Plan unavailable — try another';
          setTimeout(function () { renderBundle(); }, 2200);
          return;
        }
        if (sp) line.selling_plan = sp;
        // Public line-item property: Shopify displays this beneath the product
        // at checkout. The automatic discount still owns billing and totals.
        if (sp && state.plan !== 'once' && octoberOfferActive()) {
          var regular = regularTierPrice(state.plan);
          var offer = tierPrice(state.plan);
          if (regular.available && offer.available) {
            properties['October subscription offer'] = isStickPlan()
              ? '20% off every order: $' + offer.price.toFixed(2) + ' each. Before tax.'
              : '20% off every box: $' + offer.price.toFixed(2) + ' each. Before tax.';
          }
        }
        if (sp && state.plan !== 'once' && !isStickPlan()) {
          var intro = regularTierPrice(state.plan);
          if (intro.available && intro.was > intro.price) properties['Subscription offer'] = subscriptionRenewalText(state.plan);
        }
        var items = [line];

        if (!items.length) return;

        // Disable + busy state while the request is in flight
        var prevText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        purchaseBusy = true;
        syncStickyAtc();

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function (response) {
            // Try to highlight the most recently added line in the drawer.
            // /cart/add.js returns { items: [...] }; pick the last one's key.
            var addedLines = (response && response.items) || [];
            var highlightKey = addedLines.length
              ? addedLines[addedLines.length - 1].key
              : null;

            if (window.FizzyCart && typeof window.FizzyCart.refresh === 'function') {
              return window.FizzyCart.refresh(highlightKey).then(function () {
                window.FizzyCart.open();
                purchaseBusy = false;
                addBtn.disabled = false;
                renderBundle();
              });
            }
            // Drawer not on this page — bounce to /cart as a fallback
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('[FizzyIQ ATC] add failed', err);
            addBtn.textContent = (err && err.description) || 'Add failed — try again';
            // Leave button disabled briefly so the error message is readable,
            // then restore via renderBundle.
            setTimeout(function () {
              purchaseBusy = false;
              addBtn.disabled = false;
              renderBundle();
            }, 2200);
          });
      });

      // ── Buy Once link ──
      // A separate one-pouch purchase. The permalink preloads checkout with
      // only the selected pouch, without a subscription or bundle expansion.
      var buyOnceBtn = document.getElementById('buyOnceBtn');
      var buyOncePopup = document.getElementById('buyOncePopup');
      if (buyOnceBtn && buyOncePopup) {
        var onceChoices = buyOncePopup.querySelectorAll('.buy-once-popup-flavor');
        var onceError = buyOncePopup.querySelector('[data-buy-once-error]');
        var onceBusy = false;
        var onceLabel = buyOnceBtn.innerHTML;

        var onceClose = buyOncePopup.querySelector('[data-buy-once-close]');
        var oncePrice = buyOncePopup.querySelector('[data-buy-once-price]');
        var oncePreviousOverflow;
        function closeBuyOncePopup(restoreFocus) {
          if (!buyOncePopup.open) return;
          window.fizzyPopupMotion.dismiss(buyOncePopup, function () {
            buyOncePopup.close();
            if (restoreFocus) buyOnceBtn.focus({ preventScroll: true });
          });
        }
        buyOncePopup.addEventListener('close', function () {
          if (buyOncePopup.open) return;
          buyOnceBtn.setAttribute('aria-expanded', 'false');
          if (oncePreviousOverflow !== undefined) {
            document.body.style.overflow = oncePreviousOverflow;
            oncePreviousOverflow = undefined;
          }
        });
        /* Subscription upsell (Sam 2026-10-09): the selected age's Monthly plan against the same
           pouches bought one at a time, from the same live prices as the plan cards. */
        var onceUpsell = buyOncePopup.querySelector('[data-buy-once-upsell]');
        function fillOnceUpsell() {
          if (!onceUpsell) return;
          var monthly = tierPrice('1m');
          var pouches = state.age === '14+' ? 2 : 1;
          var unit = window.__fizzyPdpChildMap ? Number(window.__fizzyPdpBoxOncePrice) : priceFor('8-13', 'once').price;
          var save = unit * pouches - monthly.price;
          var ok = monthly.available && monthly.price > 0 && unit > 0 && save > 0;
          onceUpsell.hidden = !ok;
          if (!ok) return;
          var saveEl = onceUpsell.querySelector('[data-upsell-save]');
          var bodyEl = onceUpsell.querySelector('[data-upsell-body]');
          if (saveEl) saveEl.textContent = money(Math.round(save * 100) / 100);
          if (bodyEl) bodyEl.textContent = pouches + (pouches === 1 ? ' pouch' : ' pouches') + ' every 30 days for ' +
            money(monthly.price) + ', shipped free, plus a free sample kit in your first box. Renews until canceled; cancel any time.';
        }
        var onceSubscribe = buyOncePopup.querySelector('[data-buy-once-subscribe]');
        if (onceSubscribe) {
          onceSubscribe.addEventListener('click', function () {
            if (!buyOncePopup.open) return;
            window.fizzyPopupMotion.dismiss(buyOncePopup, function () {
              buyOncePopup.close();
              var monthlyTier = Array.prototype.find.call(document.querySelectorAll('.tier[data-plan="1m"]'), function (t) { return t.offsetParent !== null; });
              if (monthlyTier && !monthlyTier.classList.contains('selected')) monthlyTier.click();
              var picker = document.getElementById('flavorPicker') || monthlyTier;
              if (!picker) return;
              picker.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
              // Focus the first visible control in the picker; on phones none is focusable before a
              // flavor is chosen, so fall back to the Monthly card that was just selected.
              var control = Array.prototype.find.call(picker.querySelectorAll('button:not(:disabled), [tabindex="0"]'), function (el) { return el.offsetParent !== null; }) || monthlyTier;
              if (control) control.focus({ preventScroll: true });
            });
          });
        }
        function openBuyOncePopup() {
          window.fizzyPopupMotion.reveal(buyOncePopup, function () {
            if (onceError) { onceError.textContent = ''; onceError.hidden = true; }
            fillOnceUpsell();
            var price = buyOnceBtn.querySelector('.bo-price');
            if (oncePrice && price) oncePrice.textContent = price.textContent;
            oncePreviousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            buyOncePopup.showModal();
            buyOnceBtn.setAttribute('aria-expanded', 'true');
            if (onceClose) onceClose.focus({ preventScroll: true });
          });
        }
        buyOnceBtn.addEventListener('click', function (event) {
          if (onceBusy || buyOnceBtn.disabled) return;
          event.stopPropagation();
          if (!buyOncePopup.open) openBuyOncePopup();
          else closeBuyOncePopup(true);
        });
        if (onceClose) onceClose.addEventListener('click', function () { closeBuyOncePopup(true); });
        // Native dialog contains focus. Only a click entirely outside its bounds
        // dismisses it; dragging from a flavor row onto the backdrop does not.
        var onceBackdropDown = false;
        function outsideOnce(event) {
          var rect = buyOncePopup.getBoundingClientRect();
          return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        }
        buyOncePopup.addEventListener('pointerdown', function (event) { onceBackdropDown = outsideOnce(event); });
        buyOncePopup.addEventListener('click', function (event) {
          if (onceBackdropDown && outsideOnce(event)) closeBuyOncePopup(true);
          onceBackdropDown = false;
        });
        buyOncePopup.addEventListener('cancel', function (event) {
          event.preventDefault();
          closeBuyOncePopup(true);
        });
        function resetOnceCheckout() {
          onceBusy = false;
          buyOnceBtn.disabled = false;
          buyOnceBtn.innerHTML = onceLabel;
          onceChoices.forEach(function (button) { button.disabled = false; });
          closeBuyOncePopup(false);
        }
        window.addEventListener('pageshow', resetOnceCheckout);

        function checkoutOneTime(flavorKey) {
          if (onceBusy) return;
          // Missing child mappings must never fall back to a box parent.
          // Legacy 8–13 Try It Once variants represent one pouch.
          var isBox = !!window.__fizzyPdpChildMap;
          var variant = isBox ? boxChildFor(flavorKey) : pdpVariant(flavorKey, '8-13', 'once');
          var id = variant && String(variant.id).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
          if (!variant || !/^[1-9]\d*$/.test(id) || variant.available === false || (isBox && flavorStock(flavorKey, 'once') < 1)) {
            if (onceError) {
              onceError.textContent = 'This flavor is unavailable. Please choose another pouch.';
              onceError.hidden = false;
            }
            return;
          }
          onceBusy = true;
          onceLabel = buyOnceBtn.innerHTML;
          buyOnceBtn.disabled = true;
          buyOnceBtn.textContent = 'Opening checkout…';
          onceChoices.forEach(function (button) { button.disabled = true; });
          closeBuyOncePopup(false);
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.assign(root + 'cart/' + id + ':1');
        }
        onceChoices.forEach(function (button) {
          button.addEventListener('click', function () { checkoutOneTime(button.dataset.flavor); });
        });
      }
      // ── End buy-once flow ──
    }

    document.querySelectorAll('[data-stick-mix]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!isStickPlan() || purchaseBusy || !stickPrice().available) return;
        resetFlavorCounts();
        var groups = stickSize() / 3;
        while (groups-- > 0) {
          var choices = ['bc','sl','wm','ob'].filter(canAddFlavor).sort(function (a,b) { return state.qty[a] - state.qty[b]; });
          if (!choices.length) break;
          state.qty[choices[0]] += 3;
        }
        renderBundle();
      });
    });
    // Select once on entry. Explicit available plan links take precedence;
    // otherwise compare the actual upfront prices of current subscription tiers.
    function selectInitialPlan() {
      var choices = [];
      hero.querySelectorAll('.tier[data-plan]').forEach(function (node) {
        var plan = node.dataset.plan;
        if (['stick15', '1m', '3m'].indexOf(plan) === -1 || choices.some(function (choice) { return choice.plan === plan; })) return;
        var offer = tierPrice(plan);
        if (offer.available && Number.isFinite(offer.price) && offer.price > 0) {
          choices.push({node: node, plan: plan, price: offer.price});
        }
      });
      var requested = new URLSearchParams(window.location.search).get('plan');
      var chosen = choices.find(function (choice) { return choice.plan === requested; });
      // Default to Monthly (Sam 2026-10-23); lowest price is only the fallback.
      if (!chosen) chosen = choices.find(function (choice) { return choice.plan === '1m'; });
      if (!chosen) {
        chosen = choices.reduce(function (lowest, choice) {
          return !lowest || choice.price < lowest.price ? choice : lowest;
        }, null);
      }
      if (chosen) chosen.node.click();
    }
    selectInitialPlan();
    renderBundle();


    // ── Sticky ATC visibility ──
    // Show the sticky bar once the main #addToCartBtn scrolls out of
    // view; hide it again when the user scrolls back to the buy box.
    // IntersectionObserver is GPU-cheap (no scroll handler running on
    // every frame) and handles initial state correctly — on a tall
    // mobile viewport where the ATC starts below the fold, the bar
    // will slide in on first paint.
    (function setupStickyAtc() {
      if (!stickyAtc || !addBtn) return;
      // Portal the sticky bar to <body> so it escapes the .pdp-hero
      // stacking context (.pdp-hero uses isolation: isolate for its
      // flavor-field crossfade; without this move, any later page
      // section would render above the entire hero stacking context
      // and hide the sticky bar). Only relocate if it's not already
      // there — guards against re-runs in the section editor.
      if (stickyAtc.parentNode !== document.body) {
        document.body.appendChild(stickyAtc);
      }
      if (stickyAtcBtn) {
        /* Sticky ATC click — smooth-scroll to the buy box on every
           viewport. Reverted 2026-05-30 per Sam: the bar is a "get
           me back to where I can buy" affordance, not a parallel
           commit path. Target priority: .age-picker → .pdp-right →
           #flavorPicker (last resort, still inside the buy box).
           scroll-margin-top on .age-picker (set in fizzy-dark.css)
           keeps it clear of the fixed header. */
        stickyAtcBtn.addEventListener('click', function () {
          if (optimizedPurchase) {
            if (purchaseBusy) return;
            if (!addBtn.disabled) { addBtn.click(); return; }
            var picker = tierPrice(state.plan).available ? document.getElementById('flavorPicker') : document.querySelector('.plans');
            if (picker) {
              picker.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
              var control = picker.querySelector('button:not(:disabled), [role="radio"][tabindex="0"]');
              if (control) control.focus({ preventScroll: true });
            }
            return;
          }

          var target = document.querySelector('.age-picker') ||
                       document.querySelector('.pdp-right') ||
                       document.getElementById('flavorPicker');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
      if (!('IntersectionObserver' in window)) {
        // Old browser fallback — just leave the sticky hidden. Users
        // on these browsers can still ATC from the main buy box.
        return;
      }
      /* Compute "user has scrolled past the buy box" directly from
         the addBtn's bounding rect. This is the source of truth —
         IntersectionObserver fires it on threshold crossings, and a
         scroll listener re-checks on every scroll so the state can't
         get stuck after smooth-scrolls, widget reflows, or scroll
         interruptions. Sam 2026-06-01: prior version observed only
         IntersectionObserver crossings and the body class could end
         up out of sync (sticky bar disappeared, header reappeared
         after navigating to clinician reviews). */
      /* The first control the buy box asks for. Once it is on screen the
         shopper has arrived at the controls, and a bar telling them to go find
         the plan picker is pointing at something they are already looking at. */
      var agePicker = document.querySelector('.age-picker');

      function evalStickyState() {
        if (!addBtn) return;
        var rect = addBtn.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        /* Two ways for the buy box to be off screen, and the bar earns its
           place in both. It used to show only on `bottom < 0` — scrolled past.
           But the buy column sits well below the fold on phones and below the
           gallery on desktop, so a reader coming down the page had no flavour
           control and no route to the plan picker until they had already
           reached it. `top > vh` covers that half.

           No scroll guard: Sam wants it present from the top of the page, so
           the CTA and the flavour swatches are there before the reader has
           done anything. An earlier version held it back 240px to avoid
           slamming in at load; the bar is the primary route to the buy box on
           this layout, so being late is the worse failure. */
        var past  = rect.bottom < 0;
        var ahead = rect.top > vh;

        /* 'ahead' ends when the AGE picker enters the viewport, not when the
           add-to-cart button does (Sam 2026-08-29). Those are far apart: the
           picker is the top of the buy box and the button is the bottom of it,
           so on a phone the bar was still saying "Choose your plan" while the
           shopper was already reading the plan tiers. Scrolling further turns
           `past` true and the bar returns with the real add-to-cart label. */
        if (!optimizedPurchase && ahead && agePicker) {
          var ap = agePicker.getBoundingClientRect();
          if (ap.top < vh) ahead = false;
        }

        var mode  = past ? 'past' : (ahead ? 'ahead' : null);
        if (optimizedPurchase && window.matchMedia('(min-width: 1025px)').matches) mode = null;

        if (mode !== stickyMode) {
          stickyMode = mode;
          if (stickyAtcBtn) stickyAtcBtn.innerHTML = stickyLabelFor(mode);
          stickyAtc.setAttribute('data-sa-mode', mode || 'hidden');
        }
        stickyAtc.classList.toggle('visible', !!mode);
        stickyAtc.setAttribute('aria-hidden', mode ? 'false' : 'true');
        /* aria-hidden alone left five focusable controls in the tab order while
           the bar was off screen: the hidden state is transform + opacity +
           pointer-events, none of which removes an element from tab order. The
           bar is portalled to <body>, so those were the last five tab stops on
           the page — four swatches and a CTA that are invisible and, being
           inside aria-hidden, silent to assistive tech (axe aria-hidden-focus).
           inert takes them out of both. Sam 2026-08-28. */
        if ('inert' in stickyAtc) stickyAtc.inert = !mode;
        document.body.classList.toggle('sticky-atc-active', !!mode);
      }

      var observer = new IntersectionObserver(function () {
        evalStickyState();
      }, {
        rootMargin: '0px',
        threshold: 0
      });
      observer.observe(addBtn);
      /* The age picker now decides half the state, so its crossings have to
         wake the same evaluator. The rAF scroll fallback below covers the
         cases where IO callbacks get stuck, as it already does for addBtn. */
      if (agePicker) observer.observe(agePicker);

      /* Scroll fallback — ensures state recovery when
         IntersectionObserver crossings get missed or fire in
         intermediate states. rAF-throttled so it's cheap. */
      var stickyScrollRaf = null;
      window.addEventListener('scroll', function () {
        if (stickyScrollRaf) return;
        stickyScrollRaf = requestAnimationFrame(function () {
          stickyScrollRaf = null;
          evalStickyState();
        });
      }, { passive: true });
      /* scrollend (Chrome 114+, Firefox 109+, Safari 18.2+) fires
         when scrolling stops — including after smooth-scroll-into-view
         from the FR "Read their reviews" handler. Catches the final
         state even when the rAF chain was interrupted by a fast
         user scroll. Sam 2026-06-01. */
      window.addEventListener('scrollend', evalStickyState);
      window.addEventListener('resize', evalStickyState);
      /* Expose for cross-section calls — the FR postMessage bridge
         can call this after triggering a programmatic scroll so the
         state is correct even if scrollend isn't supported in the
         current browser. */
      window.__fizzyEvalStickyState = evalStickyState;
      evalStickyState();
      // Prime the sticky's content with the initial state so the
      // first appearance has the right plan + thumb already set.
      syncStickyAtc();

      /* Flavor-tint while the hero section is in view — when the
         user is still on the hero (and a flavor that isn't BC is
         selected), the sticky ATC adopts that flavor's deep color
         so the bar reads as a continuation of the hero's flavor
         field. Once the user scrolls past the hero, the bar
         reverts to BC indigo. Sam 2026-06-01. */
      if (hero) {
        var heroTintObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            document.body.classList.toggle('sticky-atc-tinted', entry.isIntersecting);
          });
        }, {
          rootMargin: '0px',
          threshold: 0
        });
        heroTintObserver.observe(hero);
      }

      // ── Bottom-of-page spacer ──
      // The sticky bar permanently occupies a strip at the viewport
      // bottom. Without a matching spacer, the footer's last lines
      // (copyright, cert badges, etc.) stay covered no matter how
      // far the user scrolls. Mark <body> with a class and set a
      // CSS variable equal to the bar's measured height — the CSS
      // rule in fizzy-dark.css uses that variable to extend the
      // page just enough that the footer can scroll fully clear.
      document.body.classList.add('has-sticky-atc');
      function applyStickySpacer() {
        if (!stickyAtc) return;
        var h = stickyAtc.offsetHeight;
        document.documentElement.style.setProperty('--sa-height', h + 'px');
      }
      applyStickySpacer();
      // Re-measure on resize because the bar's height changes between
      // the desktop layout and the narrow-mobile (sub-380px) one.
      window.addEventListener('resize', applyStickySpacer);
    })();

    // ── Free Member Gifts modal ──
    // [data-mg-open] (the member-gifts card button) opens the modal;
    // [data-mg-close] (X + backdrop) or ESC closes it. Body scroll
    // locked while open. Sam: 2026-05-30.
    (function setupMemberGiftsModal() {
      var modal = document.getElementById('memberGiftsModal');
      var openBtns = hero.querySelectorAll('[data-mg-open]');
      var returnFocus = null;
      if (!modal || !openBtns.length) return;

      /* Force the modal to <body> root every init. Without this move
         the modal lives inside .pdp-right, which has ancestors
         (.pdp-stage / sticky sections / transformed slides) that
         create their own stacking contexts and clip backdrop-filter.
         Re-running appendChild on an already-correctly-placed node
         is a cheap no-op, so we don't bother gating on parentNode. */
      document.body.appendChild(modal);

      function openModal(event) {
        returnFocus = event.currentTarget;
        window.fizzyPopupMotion.reveal(modal, function () {
          modal.classList.add('open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var closeBtn = modal.querySelector('.mg-close');
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        });
      }
      function closeModal() {
        window.fizzyPopupMotion.dismiss(modal, function () {
          modal.classList.remove('open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        });
      }

      openBtns.forEach(function (button) { button.addEventListener('click', openModal); });
      /* Close on:
         1. Explicit [data-mg-close] (X button or backdrop)
         2. Any click outside the dialog content card (mirrors COA / SFP
            modal behavior — every popup on the site should support
            click-outside-to-close). Sam: 2026-05-30. */
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-mg-close]')) { closeModal(); return; }
        var dialog = modal.querySelector('.mg-dialog');
        if (dialog && !dialog.contains(e.target)) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
        if (e.key !== 'Tab' || modal.getAttribute('aria-hidden') !== 'false') return;

        // Re-read visible controls so the tab loop follows dynamic modal content.
        var focusable = Array.prototype.filter.call(modal.querySelectorAll(
          'a[href], area[href], button, input, select, textarea, iframe, [tabindex], [contenteditable]'
        ), function (element) {
          return element.tabIndex >= 0 && !element.matches(':disabled') &&
            !element.closest('[inert]') && element.getClientRects().length > 0 &&
            window.getComputedStyle(element).visibility === 'visible';
        });
        if (!focusable.length) { e.preventDefault(); return; }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var current = document.activeElement;
        if (e.shiftKey && (current === first || focusable.indexOf(current) < 0)) {
          e.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!e.shiftKey && (current === last || focusable.indexOf(current) < 0)) {
          e.preventDefault();
          first.focus({ preventScroll: true });
        }
      });
    })();

    // ── Info-accordion (one row open at a time) ──
    // Native <details>/<summary> handles open/close on click; the shared
    // fizzy-disclosure module animates it. The only JS here is the
    // single-open behavior: opening a row closes any other open row —
    // routed through fizzyDisclosure.close so the outgoing row collapses
    // rather than vanishing (yanking `open` skips the transition).
    // Falls back to the old instant snap if that module is absent.
    (function setupInfoAccordion() {
      var rows = hero.querySelectorAll('.info-accordion .ia-row');
      if (!rows.length) return;
      rows.forEach(function (row) {
        row.addEventListener('toggle', function () {
          if (!row.hasAttribute('open')) return;
          rows.forEach(function (other) {
            if (other !== row && other.hasAttribute('open')) {
              if (window.fizzyDisclosure) window.fizzyDisclosure.close(other);
              else other.removeAttribute('open');
            }
          });
        });
      });
    })();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Fullscreen product images. Keep native pinch zoom and a bounded image
   window: only the current image and its neighbors get reading-size sources.
   Rebuild on open for current flavor assets; release the images on close. */
(function () {
  'use strict';
  var dlg = document.getElementById('pdpZoomLightbox');
  if (!dlg) return;
  var track = document.getElementById('pdpZoomTrack');
  var dots = document.getElementById('pdpZoomThumbs');
  var slides = [];
  var activePos = -1;
  var layoutWidth = 0;
  var scrollFrame = 0;
  var PZL_REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function imageAtWidth(src, width) {
    var url = new URL(src, document.baseURI);
    if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', width);
    return url.href;
  }

  function loadNearby(pos) {
    /* Detach distant sources first so visiting the whole gallery never
       leaves eleven large images attached to the dialog. */
    slides.forEach(function (slide, i) {
      if (Math.abs(i - pos) > 1) slide.img.removeAttribute('src');
    });
    slides.forEach(function (slide, i) {
      if (Math.abs(i - pos) <= 1 && !slide.img.hasAttribute('src')) {
        slide.img.src = slide.src;
      }
    });
  }

  function activate(pos) {
    pos = Math.max(0, Math.min(pos, slides.length - 1));
    if (pos === activePos) return;
    activePos = pos;
    loadNearby(pos);
    slides.forEach(function (slide, i) {
      slide.dot.classList.toggle('active', i === pos);
      if (i === pos) slide.dot.setAttribute('aria-current', 'true');
      else slide.dot.removeAttribute('aria-current');
    });
    var active = slides[pos].dot;
    var target = active.offsetLeft - (dots.clientWidth - active.offsetWidth) / 2;
    /* One update per selected image, not a new animation every scroll frame. */
    dots.scrollTo({ left: target, behavior: 'auto' });
  }

  function select(pos, animate) {
    var distance = Math.abs(pos - activePos);
    activate(pos);
    track.scrollTo({
      left: activePos * track.clientWidth,
      /* Jumping across the gallery should not decode every image en route. */
      behavior: animate && distance === 1 && !PZL_REDUCE ? 'smooth' : 'auto'
    });
  }

  function build() {
    var readingWidth = Math.min(2400, Math.max(1600, document.documentElement.clientWidth * 2));
    document.querySelectorAll('.pdp-stage .slide').forEach(function (slide) {
      if (slide.querySelector('video')) return;
      var source = slide.querySelector('img');
      if (!source || !source.getAttribute('src')) return;
      var cell = document.createElement('div');
      cell.className = 'pzl-slide';
      var img = document.createElement('img');
      img.alt = source.getAttribute('alt') || '';
      img.decoding = 'async';
      cell.appendChild(img);
      track.appendChild(cell);
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pzl-thumb';
      dot.setAttribute('aria-label', 'Image ' + (slides.length + 1) + ' of the carousel');
      var thumb = document.createElement('img');
      thumb.src = imageAtWidth(source.getAttribute('src'), 160);
      thumb.alt = '';
      thumb.width = 46;
      thumb.height = 46;
      thumb.decoding = 'async';
      dot.appendChild(thumb);
      var pos = slides.length;
      dot.addEventListener('click', function () { select(pos, true); });
      dots.appendChild(dot);
      slides.push({
        index: parseInt(slide.dataset.i, 10),
        src: imageAtWidth(source.getAttribute('src'), readingWidth),
        img: img,
        dot: dot
      });
    });
  }

  track.addEventListener('scroll', function () {
    if (!dlg.open || scrollFrame) return;
    scrollFrame = requestAnimationFrame(function () {
      scrollFrame = 0;
      if (dlg.open && slides.length) {
        activate(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      }
    });
  }, { passive: true });

  /* Observe layout width only. Pinch changes the visual viewport, which must
     not rebuild the gallery or re-center the image underneath the fingers. */
  function preserveSlide() {
    if (!dlg.open || activePos < 0 || track.clientWidth === layoutWidth) return;
    layoutWidth = track.clientWidth;
    track.scrollTo({ left: activePos * layoutWidth, behavior: 'auto' });
  }
  if ('ResizeObserver' in window) new ResizeObserver(preserveSlide).observe(track);
  else window.addEventListener('resize', preserveSlide);

  dlg.addEventListener('close', function () {
    if (scrollFrame) cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
    slides.forEach(function (slide) { slide.img.removeAttribute('src'); });
    track.replaceChildren();
    dots.replaceChildren();
    slides = [];
    activePos = -1;
  });

  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-pdp-zoom]')) {
      if (dlg.open) return;
      build();
      if (!slides.length) return;
      window.fizzyPopupMotion.open(dlg);
      layoutWidth = track.clientWidth;
      var counter = document.getElementById('pdpCounter');
      var current = counter ? parseInt(counter.textContent, 10) - 1 : 0;
      var pos = slides.findIndex(function (slide) { return slide.index === current; });
      select(Math.max(pos, 0), false);
      return;
    }
    if (t.closest('[data-pzl-close]') || t === dlg) window.fizzyPopupMotion.close(dlg);
  });
})();